(function (global) {
  'use strict';

  if (global && global.GBLD && global.GBLD.version === '1.4.3') {
    if (typeof module !== 'undefined' && module.exports) module.exports = global.GBLD.engine;
    return;
  }

  var storageKey = 'gbld:v1:sel';
  var lockCount = 0;

  function currencyStep(currency) {
    var digits = 2;
    if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
      try {
        digits = new Intl.NumberFormat('en', { style: 'currency', currency: currency }).resolvedOptions().maximumFractionDigits;
      } catch (error) {
        digits = 2;
      }
    }
    return Math.max(1, Math.pow(10, Math.max(0, 2 - digits)));
  }

  function tierIndexFor(count, tiers) {
    var index = -1;
    for (var i = 0; i < tiers.length; i += 1) {
      if (Number(tiers[i].qty) <= count) index = i;
      else break;
    }
    return index;
  }

  function tierProgressCount(tier, eligibleCount, pickedEligibleCount) {
    return tier && (tier.milestone === 'mystery' || tier.gift)
      ? Math.max(0, Number(pickedEligibleCount) || 0)
      : Math.max(0, Number(eligibleCount) || 0);
  }

  function tierProgressFor(index, tiers, eligibleCount, pickedEligibleCount) {
    var tier = tiers && tiers[index];
    var progressCount = tierProgressCount(tier, eligibleCount, pickedEligibleCount);
    var currentIndex = -1;
    var i;
    if (tiers) {
      for (i = 0; i < tiers.length; i += 1) {
        if (Number(tiers[i].qty) <= tierProgressCount(tiers[i], eligibleCount, pickedEligibleCount)) currentIndex = i;
        else break;
      }
    }
    return {
      reached: !!tier && Number(tier.qty) <= progressCount,
      current: !!tier && currentIndex === Number(index),
      remaining: tier ? Math.max(0, Number(tier.qty) - progressCount) : 0
    };
  }

  function tierIndexForProgress(eligibleCount, pickedEligibleCount, tiers) {
    var index = -1;
    for (var i = 0; i < tiers.length; i += 1) {
      if (Number(tiers[i].qty) <= tierProgressCount(tiers[i], eligibleCount, pickedEligibleCount)) index = i;
      else break;
    }
    return index;
  }

  function meterSlotForTier(tier, units, rewards) {
    rewards = rewards || {};
    if (!tier) return null;
    if (tier.milestone === 'mystery') {
      return rewards.mysteryUnlocked && rewards.mysteryImage
        ? { cart: false, image: rewards.mysteryImage }
        : null;
    }
    if (tier.gift) {
      return rewards.giftUnlocked && rewards.giftImage
        ? { cart: false, image: rewards.giftImage }
        : null;
    }
    return units && units[Number(tier.qty) - 1] ? units[Number(tier.qty) - 1] : null;
  }

  function pillTierIndex(tierIndex, tiers) {
    for (var i = Math.min(Number(tierIndex), tiers.length - 1); i >= 0; i -= 1) {
      if (!tiers[i].gift) return i;
    }
    return -1;
  }

  function unitDiscount(unitCents, pct, step) {
    if (!step || step < 1) step = 1;
    return Math.floor(unitCents * pct / 100 / step) * step;
  }

  function truePercent(compare, finalPrice) {
    return compare > finalPrice ? Math.floor((compare - finalPrice) * 100 / compare) : 0;
  }

  function sizedImage(url, width) {
    if (typeof url !== 'string' || !url) return '';
    var hashIndex = url.indexOf('#');
    var hash = hashIndex === -1 ? '' : url.slice(hashIndex);
    var withoutHash = hashIndex === -1 ? url : url.slice(0, hashIndex);
    var queryIndex = withoutHash.indexOf('?');
    var path = queryIndex === -1 ? withoutHash : withoutHash.slice(0, queryIndex);
    var query = queryIndex === -1 ? '' : withoutHash.slice(queryIndex + 1);
    var params = query ? query.split('&') : [];
    var widthValue = 'width=' + String(width);
    var found = false;
    var kept = [];
    params.forEach(function (param) {
      if (param.split('=')[0] !== 'width') {
        kept.push(param);
      } else if (!found) {
        kept.push(widthValue);
        found = true;
      }
    });
    if (!found) kept.push(widthValue);
    return path + '?' + kept.join('&') + hash;
  }

  function leftAfterSubmit(current, submitted, lowest) {
    var quantity = Math.max(0, Number(current) || 0);
    var sent = Math.max(0, Number(submitted) || 0);
    var minimum = Math.max(0, Number(lowest) || 0);
    return Math.max(0, quantity - Math.min(sent, minimum));
  }

  function safeShopifyMediaUrl(value) {
    if (typeof value !== 'string' || !value) return '';
    try {
      var base = (global && global.location && global.location.origin && global.location.origin !== 'null') ? global.location.origin + '/' : 'https://shellblaster.co/';
      if (documentRef && documentRef.baseURI) {
        try {
          var documentUrl = new URL(documentRef.baseURI);
          documentUrl.protocol = 'https:';
          base = documentUrl.toString();
        } catch (error) {}
      }
      var source = value.indexOf('//') === 0 ? 'https:' + value : value;
      var parsed = new URL(source, base);
      if (parsed.protocol !== 'https:' || parsed.username || parsed.password) return '';
      if (parsed.host === 'cdn.shopify.com') return parsed.toString();
      var trustedStoreHost = parsed.host === 'getblaster.co' || parsed.host === 'www.getblaster.co' || parsed.host === 'shellblaster.co' || parsed.host === 'www.shellblaster.co' || parsed.host === 'the-blaster-store.myshopify.com';
      if (!trustedStoreHost || parsed.pathname.indexOf('/cdn/shop/') !== 0) return '';
      return parsed.toString();
    } catch (error) { return ''; }
  }

  function stopVideoElement(video) {
    if (!video) return;
    try { video.pause(); } catch (error) {}
    try { video.removeAttribute('src'); } catch (error) {}
    try {
      if (video.querySelectorAll) {
        Array.prototype.forEach.call(video.querySelectorAll('source'), function (source) {
          if (source.parentNode) source.parentNode.removeChild(source);
        });
      }
    } catch (error) {}
    try { video.removeAttribute('controls'); } catch (error) {}
    try { video.load(); } catch (error) {}
  }

  function startVideoElement(video, source, poster) {
    var safeSource = safeShopifyMediaUrl(source);
    if (!video || !safeSource) return false;
    stopVideoElement(video);
    try {
      video.preload = 'none';
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('preload', 'none');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('controls', '');
      var safePoster = safeShopifyMediaUrl(poster);
      if (safePoster) video.setAttribute('poster', safePoster);
      video.setAttribute('src', safeSource);
      video.load();
      return video.play();
    } catch (error) { return false; }
  }

  function hasBosGift(state) {
    return !!(state && Array.isArray(state.items) && state.items.some(function (item) {
      return item && item.bosGift === true;
    }));
  }

  function rewardReadyForMarket(ready, currency, country) {
    return !!ready && String(currency || '').toUpperCase() === 'USD' && String(country || '').toUpperCase() === 'US';
  }

  function canUnlockMysteryGift(pickedCount, mysteryReady) {
    return !!mysteryReady && Math.max(0, Number(pickedCount) || 0) >= 4;
  }

  function hasTaggedMysteryGift(state, mysteryVariantId) {
    if (!state || !Array.isArray(state.items) || mysteryVariantId == null || mysteryVariantId === '') return false;
    return state.items.some(function (item) {
      return item && String(item.variant_id) === String(mysteryVariantId) && item.bosMystery === true;
    });
  }

  function planBundleRewards(paidItems, options) {
    options = options || {};
    var items = (Array.isArray(paidItems) ? paidItems : []).map(function (item) {
      var planned = { id: String(item.id), quantity: item.quantity, eligible: !!item.eligible };
      if (Object.prototype.hasOwnProperty.call(item, 'rewardEligible')) planned.rewardEligible = !!item.rewardEligible;
      return planned;
    });
    var mysteryIncluded = !!options.mysteryUnlocked;
    var mysteryAdded = mysteryIncluded && !options.mysteryAlreadyInCart && !!options.mysteryId;
    var freeBlasterAdded = !!options.freeBlasterUnlocked && !!options.freeBlasterId;
    if (mysteryAdded) items.push({ id: String(options.mysteryId), quantity: 1, gift: true, mystery: true });
    if (freeBlasterAdded) items.push({ id: String(options.freeBlasterId), quantity: 1, gift: true });
    return {
      items: items,
      tagPaid: mysteryIncluded || freeBlasterAdded,
      mysteryIncluded: mysteryIncluded,
      mysteryAdded: mysteryAdded,
      freeBlasterAdded: freeBlasterAdded
    };
  }

  function productIdNumber(value) {
    var id = String(value || '').replace(/\/$/, '').split('/').pop();
    return /^\d+$/.test(id) ? id : '';
  }

  function giftPaidProductSet(ids) {
    if (!Array.isArray(ids) || ids.length !== 42) return new Set();
    var values = new Set();
    for (var i = 0; i < ids.length; i += 1) {
      var value = String(ids[i] || '');
      if (!/^gid:\/\/shopify\/Product\/\d+$/.test(value)) return new Set();
      var numericId = productIdNumber(value);
      if (!numericId || values.has(numericId)) return new Set();
      values.add(numericId);
    }
    return values;
  }

  function isGiftPaidLine(line, paidProductIds) {
    var unitPrice = line ? Number(line.price) : NaN;
    return !!(line && line.eligible && line.kind === 'blaster' && isFinite(unitPrice) && unitPrice > 0 &&
      paidProductIds instanceof Set && paidProductIds.has(productIdNumber(line.productId)));
  }

  function giftEligibleQty(lines, paidProductIds) {
    if (!Array.isArray(lines) || !(paidProductIds instanceof Set)) return 0;
    return lines.reduce(function (sum, line) {
      if (!isGiftPaidLine(line, paidProductIds)) return sum;
      return sum + Math.max(0, Number(line.qty) || 0);
    }, 0);
  }

  function variantDisplay(handle, family, cardTitle, shortTitle, familyTitle) {
    if (String(handle || '') === 'raven') {
      var ravenFamily = family === 'normal' ? 'normal' : 'brick';
      var ravenTitle = ravenFamily === 'normal'
        ? String(familyTitle || 'Raven Shellblaster')
        : String(familyTitle || 'Raven Brick Shellblaster');
      return { family: ravenFamily, title: ravenTitle, short: ravenTitle };
    }
    return {
      family: String(family || 'default'),
      title: String(cardTitle || ''),
      short: String(shortTitle || cardTitle || '')
    };
  }

  function canUnlockFreeGift(pickedCount, giftQty, giftReady, cartHasGift) {
    var picked = Math.max(0, Number(pickedCount) || 0);
    var qty = Math.max(0, Number(giftQty) || 0);
    return !!giftReady && qty > 0 && picked >= qty && !cartHasGift;
  }

  function reconcileGiftSelection(selectedId, unlocked, variantAllowed) {
    if (!unlocked || !variantAllowed || selectedId == null || selectedId === '') return null;
    return String(selectedId);
  }

  function rewardProgressMessage(pickedCount, giftQty, giftReady, mysteryGiftShown, cartHasGift, giftPicked) {
    var picked = Math.max(0, Number(pickedCount) || 0);
    var qty = Math.max(0, Number(giftQty) || 0);
    if (mysteryGiftShown && picked === 3) return '1 more: Mystery Gift included';
    if (giftReady && qty > 0) {
      if (cartHasGift) return mysteryGiftShown && picked >= 4 ? 'Mystery Gift included' : 'One free blaster per cart';
      if (picked > qty) return 'Mystery Gift included · Buy 5, pick 1 FREE';
      if (picked >= qty) return giftPicked ? 'Mystery Gift included · Free blaster selected' : 'Mystery Gift included · Pick your FREE blaster';
      if (picked === qty - 1) return 'Mystery Gift included · 1 more for a FREE blaster';
    }
    if (mysteryGiftShown && picked >= 4) return 'Mystery Gift included';
    return '';
  }

  var zeroDecimalCurrencies = {
    BIF: true, CLP: true, DJF: true, GNF: true, ISK: true, JPY: true,
    KMF: true, KRW: true, PYG: true, RWF: true, UGX: true, UYI: true,
    VND: true, VUV: true, XAF: true, XOF: true, XPF: true
  };

  function fallbackMoney(cents, currency) {
    var amount = Number(cents) || 0;
    var sign = amount < 0 ? '-' : '';
    var absolute = Math.abs(amount);
    var code = String(currency || '');
    var digits;
    if (zeroDecimalCurrencies[code]) digits = String(Math.round(absolute / 100));
    else {
      var whole = Math.floor(absolute / 100);
      var fraction = String(Math.round(absolute) % 100).padStart(2, '0');
      digits = String(whole) + '.' + fraction;
    }
    return sign + digits + (code ? ' ' + code : '');
  }

  function price(lines, tiers, opts) {
    opts = opts || {};
    var step = Number(opts.step) || 1;
    var itemCount = 0;
    var cartEligibleQty = Math.max(0, Number(opts.cartEligibleQty) || 0);
    var eligibleCount = cartEligibleQty;
    var pickedEligibleCount;
    var subtotal = 0;
    var total = 0;
    var referenceTotal = 0;
    var giftReference = Math.max(0, Math.floor(Number(opts.giftReference) || 0));
    var calculated = [];
    var index;
    var pct = 0;
    var label = '';
    var i;
    var line;
    var quantity;
    var unit;
    var compare;
    var eligible;
    var unitFinal;
    var lineFinal;
    var lineOriginal;
    var lineReference;

    for (i = 0; i < lines.length; i += 1) {
      line = lines[i];
      quantity = Number(line.qty) || 0;
      itemCount += quantity;
      if (line.eligible) eligibleCount += quantity;
    }
    pickedEligibleCount = opts.pickedEligibleQty == null
      ? Math.max(0, eligibleCount - cartEligibleQty)
      : Math.max(0, Number(opts.pickedEligibleQty) || 0);
    index = tierIndexForProgress(eligibleCount, pickedEligibleCount, tiers);
    if (index >= 0) {
      pct = Number(tiers[index].pct) || 0;
      label = tiers[index].label || '';
    }
    for (i = 0; i < lines.length; i += 1) {
      line = lines[i];
      quantity = Number(line.qty) || 0;
      unit = Number(line.price) || 0;
      compare = Number(line.compare) || 0;
      eligible = !!line.eligible;
      unitFinal = eligible ? unit - unitDiscount(unit, pct, step) : unit;
      lineFinal = unitFinal * quantity;
      lineOriginal = unit * quantity;
      lineReference = Math.max(unit, compare) * quantity;
      subtotal += lineOriginal;
      total += lineFinal;
      referenceTotal += lineReference;
      calculated.push({
        id: line.id,
        qty: quantity,
        unit: unit,
        unitFinal: unitFinal,
        lineFinal: lineFinal,
        lineOriginal: lineOriginal,
        lineReference: lineReference
      });
    }
    referenceTotal += giftReference;
    var nextIndex = index + 1;
    var next = null;
    if (nextIndex < tiers.length) {
      var nextProgressCount = tierProgressCount(tiers[nextIndex], eligibleCount, pickedEligibleCount);
      next = {
        index: nextIndex,
        qty: Number(tiers[nextIndex].qty),
        pct: Number(tiers[nextIndex].pct) || 0,
        label: tiers[nextIndex].label || '',
        remaining: Math.max(0, Number(tiers[nextIndex].qty) - nextProgressCount)
      };
    }
    return {
      itemCount: itemCount,
      eligibleCount: eligibleCount,
      pickedEligibleCount: pickedEligibleCount,
      tierIndex: index,
      pct: pct,
      label: label,
      next: next,
      lines: calculated,
      subtotal: subtotal,
      total: total,
      referenceTotal: referenceTotal,
      saving: referenceTotal - total
    };
  }

  function freeShipping(amountCents, baseCents, rate) {
    var goal = Math.round(baseCents * rate);
    var amount = Number(amountCents) || 0;
    return {
      goal: goal,
      remaining: Math.max(0, goal - amount),
      done: amount >= goal,
      percent: goal > 0 ? Math.min(100, Math.round(amount / goal * 1000) / 10) : 100
    };
  }

  function eligibleQtyInCart(cartState, tierCollections) {
    if (!cartState || !Array.isArray(cartState.items)) return 0;
    var handles = tierCollections instanceof Set ? tierCollections : new Set(tierCollections || []);
    var excludedHandles = new Set(['outlaw-1873-deal', 'twinshot-double-barrel-foam-blaster']);
    var quantity = 0;
    cartState.items.forEach(function (item) {
      if (!item || item.gift === true || item.bosGift === true || excludedHandles.has(String(item.handle || '')) || !Array.isArray(item.collections)) return;
      if (item.collections.some(function (handle) { return handles.has(handle); })) {
        quantity += Number(item.quantity) || 0;
      }
    });
    return quantity;
  }

  function moneyFormatter(sample, currency, lang) {
    var pattern = /^(\D*)1(\D?)23(?:4(\D)(\d+)|5)(\D*)$/;
    var match = pattern.exec(String(sample || ''));
    if (!match) {
      return function (cents) {
        try {
          if (typeof Intl !== 'undefined' && Intl.NumberFormat) {
            return new Intl.NumberFormat(lang || 'en', { style: 'currency', currency: currency }).format((Number(cents) || 0) / 100);
          }
        } catch (error) {}
        return fallbackMoney(cents, currency);
      };
    }
    var prefix = match[1];
    var grouping = match[2] || '';
    var decimal = match[3] || '';
    var places = match[4] ? match[4].length : 0;
    var suffix = match[5] || '';
    return function (cents) {
      var amount = Number(cents) || 0;
      var sign = amount < 0 ? '-' : '';
      var absolute = Math.abs(amount);
      var divisor = 100;
      var whole;
      var fraction;
      if (places === 0) {
        whole = Math.round(absolute / divisor);
        fraction = '';
      } else {
        whole = Math.floor(absolute / divisor);
        fraction = String(absolute % divisor).padStart(2, '0');
        if (places > 2) fraction += new Array(places - 1).join('0');
        else if (places < 2) fraction = fraction.slice(0, places);
      }
      var grouped = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, grouping);
      return sign + prefix + grouped + (places ? decimal + fraction : '') + suffix;
    };
  }

  // 1.4.2: long "Fits A + B + C" gear headers step down in size so they stay within two lines on a 390px phone.
  function groupTitleSize(text) {
    var length = String(text || '').length;
    if (length > 64) return 'xl';
    if (length > 36) return 'l';
    if (length > 24) return 'm';
    return '';
  }

  var engine = {
    currencyStep: currencyStep,
    tierIndexFor: tierIndexFor,
    tierProgressCount: tierProgressCount,
    tierProgressFor: tierProgressFor,
    tierIndexForProgress: tierIndexForProgress,
    meterSlotForTier: meterSlotForTier,
    pillTierIndex: pillTierIndex,
    unitDiscount: unitDiscount,
    truePercent: truePercent,
    price: price,
    sizedImage: sizedImage,
    leftAfterSubmit: leftAfterSubmit,
    safeShopifyMediaUrl: safeShopifyMediaUrl,
    stopVideoElement: stopVideoElement,
    startVideoElement: startVideoElement,
    hasBosGift: hasBosGift,
    rewardReadyForMarket: rewardReadyForMarket,
    giftPaidProductSet: giftPaidProductSet,
    isGiftPaidLine: isGiftPaidLine,
    giftEligibleQty: giftEligibleQty,
    variantDisplay: variantDisplay,
    canUnlockMysteryGift: canUnlockMysteryGift,
    hasTaggedMysteryGift: hasTaggedMysteryGift,
    planBundleRewards: planBundleRewards,
    canUnlockFreeGift: canUnlockFreeGift,
    reconcileGiftSelection: reconcileGiftSelection,
    rewardProgressMessage: rewardProgressMessage,
    freeShipping: freeShipping,
    eligibleQtyInCart: eligibleQtyInCart,
    moneyFormatter: moneyFormatter,
    groupTitleSize: groupTitleSize
  };

  if (typeof module !== 'undefined' && module.exports) module.exports = engine;
  if (!global || !global.document) return;

  var documentRef = global.document;

  function readInteger(value, fallback) {
    var parsed = parseInt(value, 10);
    return isFinite(parsed) ? parsed : fallback;
  }

  function clearNode(node) {
    if (!node) return;
    while (node.firstChild) node.removeChild(node.firstChild);
  }

  function replacePlaceholders(template, values) {
    return String(template || '').replace(/\[(count|label|amount|name)\]/g, function (token, key) {
      return Object.prototype.hasOwnProperty.call(values, key) ? String(values[key]) : '';
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-gbld-ready') === '1') return false;

    var missing = [];
    var requiredSelectors = [
      '[data-gbld-tabs]', '[data-gbld-tab]', '[data-gbld-tab-pill]', '[data-gbld-panel]', '[data-gbld-backdrop]',
      '[data-gbld-summary]', '[data-gbld-summary-toggle]', '[data-gbld-summary-close]', '[data-gbld-count-badge]',
      '[data-gbld-message]', '[data-gbld-meter]', '[data-gbld-seg]', '[data-gbld-ship]', '[data-gbld-ship-text]',
      '[data-gbld-ship-fill]', '[data-gbld-count]', '[data-gbld-cartnote]', '[data-gbld-items]', '[data-gbld-empty]',
      '[data-gbld-total]', '[data-gbld-total-was]', '[data-gbld-saving]', '[data-gbld-submit]',
      '[data-gbld-submit-text]', '[data-gbld-error]', '[data-gbld-item-tpl]', '[data-gbld-strings]'
    ];
    requiredSelectors.forEach(function (selector) {
      if (!root.querySelector(selector)) missing.push(selector);
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-gbld-panel]'), function (panel) {
      if (!panel.querySelector('[data-gbld-grid]')) missing.push('[data-gbld-grid]');
      if (panel.getAttribute('data-gbld-kind') === 'addons') {
        if (!panel.querySelector('[data-gbld-addon-hint]')) missing.push('[data-gbld-addon-hint]');
        if (!panel.querySelector('[data-gbld-addon-empty]')) missing.push('[data-gbld-addon-empty]');
      }
    });
    Array.prototype.forEach.call(root.querySelectorAll('[data-gbld-card]'), function (card) {
      ['[data-gbld-variant]', '[data-gbld-open]', '[data-gbld-img]', '[data-gbld-card-count]', '[data-gbld-price]',
        '[data-gbld-now]', '[data-gbld-was]', '[data-gbld-save]', '[data-gbld-add]', '[data-gbld-stepper]',
        '[data-gbld-dec]', '[data-gbld-qty]', '[data-gbld-inc]'].forEach(function (selector) {
        if (!card.querySelector(selector)) missing.push(selector);
      });
      if (card.querySelectorAll('[data-gbld-variant]').length > 1 && !card.querySelector('[data-gbld-variants]')) missing.push('[data-gbld-variants]');
      if (card.getAttribute('data-kind') === 'addon' && !card.querySelector('[data-gbld-fits-tag]')) missing.push('[data-gbld-fits-tag]');
    });
    var itemTemplateForCheck = root.querySelector('[data-gbld-item-tpl]');
    if (itemTemplateForCheck && itemTemplateForCheck.content) {
      ['[data-gbld-item]', '[data-gbld-item-img]', '[data-gbld-item-title]', '[data-gbld-item-variant]',
        '[data-gbld-item-price]', '[data-gbld-item-was]', '[data-gbld-item-dec]', '[data-gbld-item-qty]',
        '[data-gbld-item-inc]'].forEach(function (selector) {
        if (!itemTemplateForCheck.content.querySelector(selector)) missing.push(selector);
      });
    }
    var configAttrs = ['currency', 'shopCurrency', 'moneySample', 'cartAddUrl', 'cartUrl', 'rootUrl', 'tiers', 'tierCollections', 'freeshipBase', 'maxQty'];
    configAttrs.forEach(function (name) {
      var attribute = 'data-' + name.replace(/[A-Z]/g, function (letter) { return '-' + letter.toLowerCase(); });
      if (root.getAttribute(attribute) == null) missing.push(attribute);
    });
    var stringsNode = root.querySelector('[data-gbld-strings]');
    var strings = {};
    if (stringsNode) {
      try { strings = JSON.parse(stringsNode.textContent || '{}'); }
      catch (error) { missing.push('[data-gbld-strings] JSON'); }
    }
    if (missing.length) {
      if (global.console && typeof global.console.warn === 'function') global.console.warn('[gbld] missing required hook: ' + missing[0]);
      return false;
    }

    var configuredGiftQty = Math.max(0, readInteger(root.getAttribute('data-gift-qty'), 0));
    var currency = root.getAttribute('data-currency') || '';
    var country = root.getAttribute('data-country') || '';
    var giftMarker = root.getAttribute('data-gift-marker') || '';
    var mysteryGiftId = root.getAttribute('data-mystery-gift-id') || '';
    var mysteryGiftMarker = root.getAttribute('data-mystery-gift-marker') || '';
    var mysteryGiftTitle = root.getAttribute('data-mystery-gift-title') || 'Mystery Gift';
    var mysteryGiftImage = safeShopifyMediaUrl(root.getAttribute('data-mystery-gift-image') || '');
    var mysteryGiftPrice = Math.max(0, readInteger(root.getAttribute('data-mystery-gift-price'), 0));
    var rewardMarketReady = engine.rewardReadyForMarket(true, currency, country);
    var mysteryGiftReady = rewardMarketReady && root.getAttribute('data-mystery-gift-ready') === 'true' &&
      mysteryGiftId === '45217054261427' && mysteryGiftMarker === giftMarker + ':mystery' && !!mysteryGiftImage;
    var giftReady = rewardMarketReady && mysteryGiftReady && root.getAttribute('data-gift-ready') === 'true';
    var mysteryGiftShown = mysteryGiftReady;
    var detailsNode = root.querySelector('[data-gbld-product-details]');
    var productDetails = {};
    var giftAllowedVariantIds = new Set();
    var giftPaidProductIds = new Set();
    if (detailsNode) {
      try {
        var parsedDetails = JSON.parse(detailsNode.textContent || '{}');
        productDetails = parsedDetails && parsedDetails.products && typeof parsedDetails.products === 'object' ? parsedDetails.products : {};
        giftPaidProductIds = engine.giftPaidProductSet(parsedDetails && parsedDetails.giftPaidProductIds);
        giftAllowedVariantIds = new Set(Array.isArray(parsedDetails && parsedDetails.giftVariantIds)
          ? parsedDetails.giftVariantIds.map(function (id) { return String(id); })
          : []);
      } catch (error) {
        if (global.console && typeof global.console.warn === 'function') global.console.warn('[gbld] invalid product details JSON');
      }
    }
    if (giftPaidProductIds.size !== 42) {
      mysteryGiftReady = false;
      giftReady = false;
      mysteryGiftShown = false;
    }
    var giftVariantNodes = Array.prototype.slice.call(root.querySelectorAll('[data-gbld-card] [data-gbld-variant]'));
    var hasAllowedGiftVariant = false;
    giftVariantNodes.forEach(function (node) {
      var card = node.closest('[data-gbld-card]');
      var allowed = giftAllowedVariantIds.has(String(node.getAttribute('data-id') || '')) &&
        !!card && card.getAttribute('data-kind') === 'blaster' && card.getAttribute('data-eligible') === 'true';
      node.setAttribute('data-gift-allowed', allowed ? 'true' : 'false');
      if (allowed) hasAllowedGiftVariant = true;
    });
    if (!hasAllowedGiftVariant) giftReady = false;
    var giftQty = giftReady ? configuredGiftQty : 0;
    var tiers;
    try { tiers = JSON.parse(root.getAttribute('data-tiers') || '[]'); }
    catch (error) {
      if (global.console && typeof global.console.warn === 'function') global.console.warn('[gbld] invalid tier configuration');
      return false;
    }
    if (!Array.isArray(tiers)) {
      if (global.console && typeof global.console.warn === 'function') global.console.warn('[gbld] invalid tier configuration');
      return false;
    }
    if (!mysteryGiftReady) {
      var mysteryTierIndex = tiers.findIndex(function (tier) { return tier.milestone === 'mystery'; });
      var configuredGiftTierIndex = tiers.findIndex(function (tier) { return !!tier.gift; });
      [mysteryTierIndex, configuredGiftTierIndex].forEach(function (index) {
        if (index < 0) return;
        var rewardSegment = root.querySelector('[data-gbld-seg="' + index + '"]');
        if (rewardSegment) rewardSegment.hidden = true;
      });
      tiers = tiers.filter(function (tier) { return tier.milestone !== 'mystery' && !tier.gift; });
      giftQty = 0;
    }
    var giftTierIndex = tiers.findIndex(function (tier) { return !!tier.gift; });
    var hasGiftTier = giftTierIndex !== -1;
    if (hasGiftTier && (!giftReady || !hasAllowedGiftVariant)) {
      tiers = tiers.filter(function (tier) { return !tier.gift; });
      giftQty = 0;
      var giftSegment = root.querySelector('[data-gbld-seg="' + giftTierIndex + '"]');
      if (giftSegment) giftSegment.hidden = true;
    }
    if (giftQty <= 0) tiers = tiers.filter(function (tier) { return !tier.gift; });
    if (!tiers.length) {
      if (global.console && typeof global.console.warn === 'function') global.console.warn('[gbld] invalid tier configuration');
      return false;
    }
    var formatter = moneyFormatter(root.getAttribute('data-money-sample'), currency, documentRef.documentElement.lang || 'en');
    var step = currencyStep(currency);
    var maxQty = Math.max(1, readInteger(root.getAttribute('data-max-qty'), 10));
    var freeshipBase = readInteger(root.getAttribute('data-freeship-base'), 0);
    var tierCollectionList = (root.getAttribute('data-tier-collections') || '').split(/[\s,]+/).filter(Boolean);
    var tierCollectionSet = new Set(tierCollectionList);
    var stringsData = strings;
    var tabsNode = root.querySelector('[data-gbld-tabs]');
    var tabPill = root.querySelector('[data-gbld-tab-pill]');
    var summary = root.querySelector('[data-gbld-summary]');
    var backdrop = root.querySelector('[data-gbld-backdrop]');
    var itemsNode = root.querySelector('[data-gbld-items]');
    var itemTemplate = root.querySelector('[data-gbld-item-tpl]');
    var submitButton = root.querySelector('[data-gbld-submit]');
    var submitText = root.querySelector('[data-gbld-submit-text]');
    var quickView = root.querySelector('[data-gbld-qv]');
    var quickViewScroll = quickView && quickView.querySelector('.gbld-qv__scroll');
    var quickViewGallery = quickView && quickView.querySelector('[data-gbld-qv-gallery]');
    var quickViewGalleryControls = quickView && quickView.querySelector('[data-gbld-qv-gallery-controls]');
    var quickViewGalleryCount = quickView && quickView.querySelector('[data-gbld-qv-count]');
    var giftBar = root.querySelector('[data-gbld-giftbar]');
    var giftDialog = root.querySelector('[data-gbld-gift]');
    var giftOptionTemplate = root.querySelector('[data-gbld-gift-tpl]');
    if (giftQty <= 0) {
      if (giftBar) giftBar.hidden = true;
      if (giftDialog) giftDialog.hidden = true;
    }
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-gbld-card]'));
    var variants = Array.prototype.slice.call(root.querySelectorAll('[data-gbld-card] [data-gbld-variant]'));
    var addonCards = cards.filter(function (card) { return card.getAttribute('data-kind') === 'addon'; });
    var addonPanelStates = Array.prototype.slice.call(root.querySelectorAll('[data-gbld-panel][data-gbld-kind="addons"]')).map(function (panel) {
      var pool = panel.querySelector('[data-gbld-grid]');
      var groupRoot = panel.querySelector('[data-gbld-groups]');
      var groupTemplate = panel.querySelector('[data-gbld-group-tpl]');
      var groupContent = groupTemplate && groupTemplate.content && groupTemplate.content.querySelector('[data-gbld-group]');
      var grouped = !!(pool && groupRoot && groupContent && groupContent.querySelector('[data-gbld-group-pics]') &&
        groupContent.querySelector('[data-gbld-group-title]') && groupContent.querySelector('[data-gbld-group-grid]'));
      return {
        panel: panel,
        pool: pool,
        groupRoot: groupRoot,
        groupTemplate: groupTemplate,
        grouped: grouped,
        cards: addonCards.filter(function (card) { return card.closest('[data-gbld-panel]') === panel; }),
        groups: [],
        dirty: true,
        fitQueued: false,
        fitFrame: null
      };
    });
    var giftCandidates = [];
    var giftCandidateByProduct = new Map();
    var giftCandidateByVariant = new Map();
    var giftFacts = new Map();
    cards.forEach(function (card) {
      if (!giftReady || card.getAttribute('data-kind') !== 'blaster' || card.getAttribute('data-eligible') !== 'true') return;
      var allowedNodes = Array.prototype.slice.call(card.querySelectorAll('[data-gbld-variant]')).filter(function (node) {
        return node.getAttribute('data-gift-allowed') === 'true';
      });
      if (!allowedNodes.length) return;
      var productId = card.getAttribute('data-product-id') || '';
      if (!productId) return;
      var candidate = giftCandidateByProduct.get(productId);
      if (!candidate) {
        candidate = { productId: productId, card: card, variants: [] };
        giftCandidateByProduct.set(productId, candidate);
        giftCandidates.push(candidate);
      }
      if (candidate.card !== card) return;
      allowedNodes.forEach(function (node) {
        var id = String(node.getAttribute('data-id') || '');
        if (!id || candidate.variants.some(function (item) { return item.id === id; })) return;
        var item = { id: id, node: node };
        candidate.variants.push(item);
        giftCandidateByVariant.set(id, candidate);
      });
    });
    var selections = new Map();
    var activeByProduct = new Map();
    var summaryOpen = false;
    var quickViewOpen = false;
    var giftDialogOpen = false;
    var giftId = null;
    var giftUnlocked = false;
    var mysteryGiftUnlocked = false;
    var mysteryAlreadyInCart = false;
    var mysteryGiftFact = {
      id: mysteryGiftId,
      productId: root.getAttribute('data-mystery-gift-product-id') || '',
      title: mysteryGiftTitle,
      short: mysteryGiftTitle,
      variantTitle: 'Default Title',
      image: mysteryGiftImage,
      price: mysteryGiftPrice,
      compare: mysteryGiftPrice,
      eligible: false
    };
    var giftReturnPending = false;
    var quickViewCard = null;
    var quickViewOpener = null;
    var giftDialogOpener = null;
    var lastTierIndex = null;
    var lastCart = null;
    var lastCartCount = null;
    var cartEligibleQty = 0;
    var cartTotal = 0;
    var cartStateData = null;
    var cartRequestId = 0;
    var cartFresh = false;
    var cartReading = null;
    var cartNeedsAnotherRead = false;
    var cartQueuedSnapshot;
    var cartQueuedSnapshotSet = false;
    var cartQueuedForce = false;
    var renderProductQuantities = new Map();
    var activeSubmit = null;
    var pendingRecovery = null;
    var pendingMarkerKey = 'gbld:v1:pending-add';
    var submitAttemptId = 0;
    var busy = false;
    var alive = true;
    var unsubscribe = null;
    var cartBound = false;
    var lastCartSignature = null;
    var feedbackTimer = null;
    var qvCloseTimer = null;
    var qvGalleryTimer = null;
    var activeDemoVideo = null;
    var activeDemoSlide = null;
    var activeGalleryIndex = 0;
    var giftCloseTimer = null;
    var groupFlashTimers = [];
    var giftOptionsBuilt = false;
    var rootClickHandler;
    var rootKeyHandler;
    var documentUnloadHandler;
    var windowResizeHandler;
    var pageshowHandler;
    var quickViewGalleryScrollHandler;
    var quickViewScrollHandler;
    var visibilityHandler;
    var cartDomContentHandler;
    var cartWindowLoadHandler;
    var cartReadyHandler;
    var ownsLock = false;

    function str(key) {
      return Object.prototype.hasOwnProperty.call(stringsData, key) ? String(stringsData[key]) : '';
    }

    function format(key, values) {
      return replacePlaceholders(str(key), values || {});
    }

    function emit(name, detail) {
      if (!documentRef || typeof global.CustomEvent !== 'function') return;
      documentRef.dispatchEvent(new global.CustomEvent(name, { bubbles: true, detail: detail }));
    }

    function setLock(locked) {
      if (locked === ownsLock) return;
      ownsLock = locked;
      lockCount += locked ? 1 : -1;
      if (lockCount < 0) lockCount = 0;
      documentRef.documentElement.classList.toggle('gbld-lock', lockCount > 0);
    }

    function syncLock() {
      setLock(summaryOpen || quickViewOpen || giftDialogOpen);
    }

    function factFromNode(node, card) {
      if (!card) return null;
      var display = engine.variantDisplay(
        card.getAttribute('data-handle') || '',
        node.getAttribute('data-family') || '',
        card.getAttribute('data-title') || '',
        card.getAttribute('data-short') || '',
        node.getAttribute('data-gift-title') || ''
      );
      return {
        id: String(node.getAttribute('data-id') || ''),
        node: node,
        card: card,
        productId: card.getAttribute('data-product-id') || '',
        kind: card.getAttribute('data-kind') || '',
        eligible: card.getAttribute('data-eligible') === 'true',
        gift: node.getAttribute('data-gift-allowed') === 'true',
        price: readInteger(node.getAttribute('data-price'), 0),
        compare: readInteger(node.getAttribute('data-compare'), 0),
        title: display.title,
        short: display.short,
        family: display.family,
        variantTitle: node.getAttribute('data-title') || '',
        image: node.getAttribute('data-image') || '',
        imageSrcset: node.getAttribute('data-image-srcset') || '',
        handle: card.getAttribute('data-handle') || '',
        url: card.getAttribute('data-url') || ''
      };
    }

    var variantFacts = new Map();
    variants.forEach(function (node) {
      var id = String(node.getAttribute('data-id') || '');
      if (id && !variantFacts.has(id)) variantFacts.set(id, factFromNode(node, node.closest('[data-gbld-card]')));
    });
    giftCandidates.forEach(function (candidate) {
      candidate.variants.forEach(function (item) {
        giftFacts.set(item.id, factFromNode(item.node, candidate.card));
      });
    });

    function factFor(id) {
      return variantFacts.get(String(id)) || null;
    }

    function giftFactFor(id) {
      return giftFacts.get(String(id)) || null;
    }

    function activeVariant(card) {
      var active = card.querySelector('[data-gbld-variant].is-active');
      if (!active) active = card.querySelector('[data-gbld-variant]');
      return active;
    }

    function setImage(card, variant) {
      var image = card.querySelector('[data-gbld-img]');
      if (!image || !variant) return;
      var src = variant.getAttribute('data-image') || '';
      var srcset = variant.getAttribute('data-image-srcset') || '';
      if (src) image.setAttribute('src', src);
      else image.removeAttribute('src');
      if (srcset) image.setAttribute('srcset', srcset);
      else image.removeAttribute('srcset');
      var handle = card.getAttribute('data-handle') || '';
      if (handle === 'raven' || handle === 'raven-classic-shellblaster') {
        var imageTitle = variant.getAttribute('data-gift-title') || card.getAttribute('data-title') || 'Raven Shellblaster';
        var imageVariant = variant.getAttribute('data-title') || '';
        image.setAttribute('alt', imageVariant && imageVariant !== 'Default Title' ? imageTitle + ' — ' + imageVariant : imageTitle);
      }
    }

    function activateVariant(card, id) {
      var productId = card.getAttribute('data-product-id') || '';
      var changed = false;
      cards.forEach(function (otherCard) {
        if ((otherCard.getAttribute('data-product-id') || '') !== productId) return;
        var matched = false;
        Array.prototype.forEach.call(otherCard.querySelectorAll('[data-gbld-variant]'), function (variant) {
          var active = String(variant.getAttribute('data-id')) === String(id);
          variant.classList.toggle('is-active', active);
          if (variant.getAttribute('role') === 'radio') variant.setAttribute('aria-checked', active ? 'true' : 'false');
          if (active) matched = true;
        });
        if (matched) {
          activeByProduct.set(productId, String(id));
          setImage(otherCard, activeVariant(otherCard));
        }
      });
      if (String(activeByProduct.get(productId)) !== String(id)) changed = true;
      else changed = true;
      return changed;
    }

    function activeId(card) {
      var variant = activeVariant(card);
      return variant ? String(variant.getAttribute('data-id') || '') : '';
    }

    function currentPrice() {
      var lines = [];
      selections.forEach(function (qty, id) {
        var fact = factFor(id);
        if (!fact) return;
        lines.push({ id: id, productId: fact.productId, kind: fact.kind, price: fact.price, compare: fact.compare, qty: qty, eligible: fact.eligible });
      });
      var baseResult = price(lines, tiers, { cartEligibleQty: cartEligibleQty, step: step });
      var hasCartGift = hasBosGift(cartStateData);
      // Native price tiers still use dynamic collection eligibility; rewards use the server-reviewed paid-product set.
      var pickedEligible = engine.giftEligibleQty(lines, giftPaidProductIds);
      mysteryAlreadyInCart = engine.hasTaggedMysteryGift(cartStateData, mysteryGiftId);
      mysteryGiftUnlocked = engine.canUnlockMysteryGift(pickedEligible, mysteryGiftReady);
      giftUnlocked = engine.canUnlockFreeGift(pickedEligible, giftQty, giftReady, hasCartGift);
      var reconciledGiftId = engine.reconcileGiftSelection(giftId, giftUnlocked, !giftId || !!giftFactFor(giftId));
      if (reconciledGiftId !== giftId) {
        giftId = reconciledGiftId;
        persist();
      }
      var giftFact = giftUnlocked && giftId ? giftFactFor(giftId) : null;
      if (!giftUnlocked && giftDialogOpen) {
        closeGiftDialog(false);
        giftReturnPending = true;
      }
      var giftReference = giftFact ? Math.max(giftFact.price, giftFact.compare) : 0;
      if (mysteryGiftUnlocked) giftReference += Math.max(mysteryGiftFact.price, mysteryGiftFact.compare);
      return price(lines, tiers, {
        cartEligibleQty: cartEligibleQty,
        pickedEligibleQty: pickedEligible,
        step: step,
        giftReference: giftReference
      });
    }

    function buildProductQuantities() {
      var quantities = new Map();
      selections.forEach(function (qty, id) {
        var fact = factFor(id);
        if (fact && fact.productId) quantities.set(fact.productId, (quantities.get(fact.productId) || 0) + qty);
      });
      renderProductQuantities = quantities;
      return quantities;
    }

    function productQuantity(productId, quantities) {
      return (quantities || renderProductQuantities).get(String(productId)) || 0;
    }

    function fitsCollection(card, collection) {
      if (!collection) return false;
      return (card.getAttribute('data-fits') || '').split(/[\s,]+/).filter(Boolean).indexOf(collection) !== -1;
    }

    function selectedBlasters() {
      var chosen = [];
      var byProduct = new Map();
      selections.forEach(function (qty, id) {
        if (qty <= 0) return;
        var fact = factFor(id);
        if (!fact || !fact.eligible || fact.kind !== 'blaster' || byProduct.has(fact.productId)) return;
        var chosenBlaster = {
          productId: fact.productId,
          name: fact.short || fact.title,
          collection: fact.card.getAttribute('data-addon-coll') || '',
          image: fact.image
        };
        chosen.push(chosenBlaster);
        byProduct.set(fact.productId, chosenBlaster);
      });
      return chosen;
    }

    function legacySelectedBlasters() {
      var chosen = [];
      cards.forEach(function (card) {
        if (card.getAttribute('data-kind') !== 'blaster') return;
        var productId = card.getAttribute('data-product-id') || '';
        if (!productId || !productQuantity(productId) || chosen.some(function (item) { return item.productId === productId; })) return;
        chosen.push({
          productId: productId,
          name: card.getAttribute('data-short') || '',
          collection: card.getAttribute('data-addon-coll') || ''
        });
      });
      return chosen;
    }

    function restoreAddonFocus(focused, card) {
      if (!focused || !card || card.hidden || !focused.isConnected || !card.contains(focused)) return;
      try { focused.focus({ preventScroll: true }); }
      catch (error) { focused.focus(); }
    }

    function paintCard(card, result, productQuantities) {
      var variant = activeVariant(card);
      if (!variant) return;
      if (card.getAttribute('data-handle') === 'raven') {
        var displayTitle = engine.variantDisplay(
          'raven', variant.getAttribute('data-family') || '', card.getAttribute('data-title') || '',
          card.getAttribute('data-short') || '', variant.getAttribute('data-gift-title') || ''
        ).title;
        var cardTitle = card.querySelector('[data-gbld-card-title]');
        if (cardTitle) cardTitle.textContent = displayTitle;
        Array.prototype.forEach.call(card.querySelectorAll('[data-gbld-open][aria-label]'), function (button) {
          button.setAttribute('aria-label', 'View details for ' + displayTitle);
        });
      }
      var id = String(variant.getAttribute('data-id') || '');
      var unit = readInteger(variant.getAttribute('data-price'), 0);
      var compare = readInteger(variant.getAttribute('data-compare'), 0);
      var eligible = card.getAttribute('data-eligible') === 'true';
      var shown = eligible ? unit - unitDiscount(unit, result.pct, step) : unit;
      var reference = Math.max(unit, compare);
      var nowNode = card.querySelector('[data-gbld-now]');
      var wasNode = card.querySelector('[data-gbld-was]');
      var saveNode = card.querySelector('[data-gbld-save]');
      var quantityNode = card.querySelector('[data-gbld-qty]');
      var addButton = card.querySelector('[data-gbld-add]');
      var stepper = card.querySelector('[data-gbld-stepper]');
      var countNode = card.querySelector('[data-gbld-card-count]');
      var qty = selections.get(id) || 0;
      if (nowNode) nowNode.textContent = formatter(shown);
      if (wasNode) {
        wasNode.textContent = formatter(reference);
        wasNode.hidden = reference <= shown;
      }
      if (saveNode) {
        // Blasters carry the store's tier label (same wording as banner, product page and cart); other products their own markdown.
        var pill = '';
        if (eligible) {
          var pillIndex = pillTierIndex(result.tierIndex, tiers);
          if (pillIndex < 0) {
            for (var tierIndex = 0; tierIndex < tiers.length; tierIndex += 1) {
              if (!tiers[tierIndex].gift) { pillIndex = tierIndex; break; }
            }
          }
          var tierForPill = pillIndex >= 0 ? tiers[pillIndex] : null;
          if (compare > unit && tierForPill && tierForPill.label) pill = String(tierForPill.label);
        } else {
          var percent = truePercent(reference, shown);
          if (percent) pill = percent + '% OFF';
        }
        saveNode.textContent = pill;
        saveNode.hidden = !pill;
      }
      if (quantityNode) quantityNode.textContent = String(qty);
      if (addButton) addButton.hidden = qty > 0;
      if (stepper) stepper.hidden = qty === 0;
      var totalProductQty = productQuantity(card.getAttribute('data-product-id') || '', productQuantities);
      card.classList.toggle('is-selected', totalProductQty > 0);
      if (countNode) {
        countNode.textContent = String(totalProductQty);
        countNode.hidden = totalProductQty === 0;
      }
      Array.prototype.forEach.call(card.querySelectorAll('[data-gbld-variant]'), function (item) {
        var active = item === variant;
        item.classList.toggle('is-active', active);
        if (item.getAttribute('role') === 'radio') item.setAttribute('aria-checked', active ? 'true' : 'false');
      });
      setImage(card, variant);
      if (addButton) addButton.disabled = qty >= maxQty;
      var dec = card.querySelector('[data-gbld-dec]');
      var inc = card.querySelector('[data-gbld-inc]');
      if (dec) dec.disabled = qty <= 0;
      if (inc) inc.disabled = qty >= maxQty;
      var gear = card.querySelector('[data-gbld-gear-for]');
      if (gear) {
        var collection = card.getAttribute('data-addon-coll') || '';
        gear.hidden = totalProductQty <= 0 || !collection || !addonCards.some(function (addon) { return fitsCollection(addon, collection); });
        if (Object.prototype.hasOwnProperty.call(stringsData, 'gear_for')) gear.textContent = str('gear_for');
      }
    }

    function fillRow(fact, qty, unitFinal) {
      var fragment = itemTemplate.content.cloneNode(true);
      var row = fragment.querySelector('[data-gbld-item]');
      if (!row) return null;
      row.setAttribute('data-id', fact.id);
      var img = row.querySelector('[data-gbld-item-img]');
      var title = row.querySelector('[data-gbld-item-title]');
      var variant = row.querySelector('[data-gbld-item-variant]');
      var priceNode = row.querySelector('[data-gbld-item-price]');
      var wasNode = row.querySelector('[data-gbld-item-was]');
      var qtyNode = row.querySelector('[data-gbld-item-qty]');
      var dec = row.querySelector('[data-gbld-item-dec]');
      var inc = row.querySelector('[data-gbld-item-inc]');
      var reference = Math.max(fact.price, fact.compare);
      if (img) {
        var rowImage = sizedImage(fact.image, 180);
        if (rowImage) img.setAttribute('src', rowImage);
        img.setAttribute('alt', fact.title);
      }
      if (title) title.textContent = fact.short || fact.title;
      if (variant) {
        variant.textContent = fact.variantTitle;
        variant.hidden = fact.variantTitle === 'Default Title';
      }
      if (priceNode) priceNode.textContent = formatter(unitFinal);
      if (wasNode) {
        wasNode.textContent = formatter(reference);
        wasNode.hidden = reference <= unitFinal;
      }
      if (qtyNode) qtyNode.textContent = String(qty);
      if (dec) dec.setAttribute('aria-label', format('dec_label', { name: fact.title }));
      if (inc) inc.setAttribute('aria-label', format('inc_label', { name: fact.title }));
      if (dec) dec.disabled = qty <= 0;
      if (inc) inc.disabled = qty >= maxQty;
      return fragment;
    }

    function giftOptionImage(option, fact) {
      var image = option.querySelector('[data-gbld-gift-option-img]');
      if (!image) return;
      var src = fact ? sizedImage(fact.image, 360) : '';
      if (src) {
        if (image.getAttribute('src') !== src) image.setAttribute('src', src);
      } else image.removeAttribute('src');
      image.setAttribute('alt', fact ? (fact.short || fact.title) : '');
    }

    function syncGiftOptions() {
      if (!giftDialog || !giftOptionsBuilt) return;
      Array.prototype.forEach.call(giftDialog.querySelectorAll('[data-gbld-gift-option]'), function (option) {
        var candidate = giftCandidateByProduct.get(option.getAttribute('data-product-id') || '');
        if (!candidate || !candidate.variants.length) return;
        var selectedCandidate = giftId ? giftCandidateByVariant.get(String(giftId)) : null;
        var activeId = selectedCandidate === candidate ? String(giftId) : '';
        var swatches = Array.prototype.slice.call(option.querySelectorAll('[data-gbld-gift-swatch]'));
        if (!activeId) {
          var activeSwatch = swatches.find(function (swatch) { return swatch.classList.contains('is-active'); });
          activeId = activeSwatch ? String(activeSwatch.getAttribute('data-id') || '') : '';
        }
        if (!activeId) {
          var activeVariantNode = candidate.variants.find(function (item) { return item.node.classList.contains('is-active'); });
          activeId = activeVariantNode ? activeVariantNode.id : candidate.variants[0].id;
        }
        swatches.forEach(function (swatch) {
          swatch.classList.toggle('is-active', String(swatch.getAttribute('data-id')) === activeId);
        });
        var variantFact = giftFactFor(activeId);
        var name = option.querySelector('[data-gbld-gift-option-name]');
        if (name) name.textContent = variantFact ? (variantFact.short || variantFact.title) : '';
        giftOptionImage(option, variantFact);
        option.classList.toggle('is-picked', !!giftId && selectedCandidate === candidate);
      });
    }

    function buildGiftOptions() {
      if (giftOptionsBuilt || !giftDialog || !giftOptionTemplate || !giftOptionTemplate.content) return;
      var grid = giftDialog.querySelector('[data-gbld-gift-grid]');
      if (!grid) return;
      giftCandidates.forEach(function (candidate) {
        if (!candidate.variants.length) return;
        var fragment = giftOptionTemplate.content.cloneNode(true);
        var option = fragment.querySelector('[data-gbld-gift-option]');
        if (!option) return;
        option.setAttribute('data-product-id', candidate.productId);
        var name = option.querySelector('[data-gbld-gift-option-name]');
        var free = option.querySelector('[data-gbld-gift-option-free]');
        if (free) free.textContent = str('gift_free');
        var initial = candidate.variants.find(function (item) { return item.node.classList.contains('is-active'); }) || candidate.variants[0];
        var initialFact = factFromNode(initial.node, candidate.card);
        if (name) name.textContent = initialFact ? (initialFact.short || initialFact.title) : '';
        giftOptionImage(option, initialFact);
        var swatchRoot = option.querySelector('[data-gbld-gift-swatches]');
        if (swatchRoot && candidate.variants.length > 1) {
          candidate.variants.forEach(function (item) {
            var button = documentRef.createElement('button');
            button.setAttribute('type', 'button');
            button.setAttribute('class', 'gbld-swatch' + (item.node.classList.contains('is-active') ? ' is-active' : ''));
            button.setAttribute('data-gbld-gift-swatch', '');
            button.setAttribute('data-id', item.id);
            button.setAttribute('aria-label', item.node.getAttribute('aria-label') || item.node.getAttribute('data-title') || '');
            Array.prototype.forEach.call(item.node.childNodes, function (child) { button.appendChild(child.cloneNode(true)); });
            swatchRoot.appendChild(button);
          });
        }
        grid.appendChild(fragment);
      });
      giftOptionsBuilt = true;
      syncGiftOptions();
    }

    function renderGiftBar() {
      if (!giftBar || giftQty <= 0) return;
      var image = giftBar.querySelector('[data-gbld-giftbar-img]');
      var text = giftBar.querySelector('[data-gbld-giftbar-text]');
      var fact = giftUnlocked && giftId ? giftFactFor(giftId) : null;
      giftBar.hidden = !giftUnlocked;
      giftBar.classList.toggle('is-empty', !fact);
      if (text) text.textContent = fact ? format('gift_chosen', { name: fact.short || fact.title }) : str('gift_pick');
      if (image) {
        var src = fact ? sizedImage(fact.image, 180) : '';
        if (src) {
          if (image.getAttribute('src') !== src) image.setAttribute('src', src);
          image.setAttribute('alt', fact.short || fact.title);
          image.hidden = false;
        } else {
          image.removeAttribute('src');
          image.setAttribute('alt', '');
          image.hidden = true;
        }
      }
      syncGiftOptions();
    }

    function fillGiftRow(fact, rewardType) {
      var fragment = fillRow(fact, 1, 0);
      if (!fragment) return null;
      var row = fragment.querySelector('[data-gbld-item]');
      var priceNode = row && row.querySelector('[data-gbld-item-price]');
      var qtyNode = row && row.querySelector('[data-gbld-item-qty]');
      var dec = row && row.querySelector('[data-gbld-item-dec]');
      var inc = row && row.querySelector('[data-gbld-item-inc]');
      if (!row) return null;
      row.setAttribute('data-gift', rewardType === 'mystery' ? 'mystery' : 'true');
      if (rewardType !== 'mystery') row.setAttribute('tabindex', '0');
      row.classList.add('is-gift');
      if (priceNode) priceNode.textContent = str('gift_free');
      if (qtyNode) qtyNode.hidden = true;
      if (dec) dec.hidden = true;
      if (inc) inc.hidden = true;
      return fragment;
    }

    function setGift(id) {
      var fact = giftFactFor(id);
      if (!giftUnlocked || !fact) return false;
      giftId = String(id);
      persist();
      render(true);
      return true;
    }

    function renderMessage(result) {
      var message = root.querySelector('[data-gbld-message]');
      if (!message) return;
      var pickedEligible = result.pickedEligibleCount;
      var rewardMessage = engine.rewardProgressMessage(
        pickedEligible,
        configuredGiftQty,
        giftReady,
        mysteryGiftShown,
        hasBosGift(cartStateData),
        !!giftId
      );
      if (rewardMessage) {
        message.textContent = rewardMessage;
        return;
      }
      if (result.eligibleCount === 0) {
        var first = null;
        for (var i = 0; i < tiers.length; i += 1) {
          if (Number(tiers[i].pct) > 0) { first = tiers[i]; break; }
        }
        message.textContent = format('msg_start', {
          count: first ? first.qty : 0,
          label: first ? first.label : ''
        });
      } else if (result.tierIndex >= tiers.length - 1 && tiers.length) {
        message.textContent = format('msg_top', { label: result.label });
      } else {
        var target = result.next;
        if (target) {
          var key = target.remaining === 1 ? 'msg_next_one' : 'msg_next_many';
          message.textContent = format(key, { count: target.remaining, label: target.label });
        } else message.textContent = '';
      }
    }

    function renderCartNote() {
      var note = root.querySelector('[data-gbld-cartnote]');
      if (!note) return;
      note.hidden = cartEligibleQty <= 0;
      if (cartEligibleQty > 0) {
        note.textContent = format(cartEligibleQty === 1 ? 'cart_note_one' : 'cart_note_many', { count: cartEligibleQty });
      }
    }

    function renderShipping(result) {
      var ship = root.querySelector('[data-gbld-ship]');
      var textNode = root.querySelector('[data-gbld-ship-text]');
      var fill = root.querySelector('[data-gbld-ship-fill]');
      if (!ship && !textNode && !fill) return;
      var rate = 1;
      try {
        rate = Number(global.Shopify && global.Shopify.currency && global.Shopify.currency.rate || 1) || 1;
      } catch (error) { rate = 1; }
      var status = freeShipping(result.total + cartTotal, freeshipBase, rate);
      if (ship) ship.classList.toggle('is-done', status.done);
      if (fill) fill.style.transform = 'translateX(-' + (100 - status.percent) + '%)';
      if (textNode) textNode.textContent = status.done
        ? format('ship_done', { amount: formatter(status.goal) })
        : format('ship_progress', { amount: formatter(status.remaining) });
    }

    // 1.4.2: headers that need more than two lines step down 1px at a time, never below 11px; if that is not enough
    // the pictures move above a full-width title. Every name and picture stays. Refit only visible panels, once per
    // animation frame, after a group rebuild, tab activation, resize or font load.
    function shrinkGroupTitle(title) {
      title.style.fontSize = '';
      var style = global.getComputedStyle(title);
      var size = parseFloat(style.fontSize);
      var ratio = parseFloat(style.lineHeight) / size;
      var height = title.getBoundingClientRect().height;
      if (!(size > 0) || !(ratio > 0) || !height) return true;
      while (size > 11 && height > size * ratio * 2 + 1) {
        size = Math.max(11, size - 1);
        title.style.fontSize = size + 'px';
        height = title.getBoundingClientRect().height;
      }
      return height <= size * ratio * 2 + 1;
    }

    function fitGroupTitles(state) {
      if (!alive || !state || !state.groupRoot || (state.panel && state.panel.hidden) || !global.getComputedStyle) return;
      Array.prototype.forEach.call(state.groupRoot.querySelectorAll('[data-gbld-group-title]'), function (title) {
        if (!title.getBoundingClientRect().height) return;
        var head = title.parentNode;
        if (head && head.removeAttribute) head.removeAttribute('data-gbld-stack');
        if (shrinkGroupTitle(title) || !head || !head.setAttribute) return;
        head.setAttribute('data-gbld-stack', '');
        shrinkGroupTitle(title);
      });
    }

    function scheduleGroupTitleFit(state) {
      if (!alive || !state || !state.grouped || !state.groupRoot || (state.panel && state.panel.hidden) || state.fitQueued) return;
      if (typeof global.requestAnimationFrame !== 'function') {
        fitGroupTitles(state);
        return;
      }
      state.fitQueued = true;
      state.fitFrame = global.requestAnimationFrame(function () {
        state.fitQueued = false;
        state.fitFrame = null;
        fitGroupTitles(state);
      });
    }

    function updateAddonFilter(forceState) {
      var hasVisibleFilter = false;
      addonPanelStates.forEach(function (state) {
        if (state.grouped && state.panel.hidden && state !== forceState) state.dirty = true;
        else hasVisibleFilter = true;
      });
      if (!hasVisibleFilter) return;
      var chosen = selectedBlasters();
      var hasLegacyFilter = addonPanelStates.some(function (state) { return !state.grouped; });
      var legacyChosen = hasLegacyFilter ? legacySelectedBlasters() : [];
      addonPanelStates.forEach(function (state) {
        var panel = state.panel;
        if (state.grouped && panel.hidden && state !== forceState) {
          state.dirty = true;
          return;
        }
        var focused = documentRef.activeElement;
        var focusedCard = focused && focused.closest ? focused.closest('[data-gbld-card]') : null;
        var focusCard = state.cards.indexOf(focusedCard) !== -1 ? focusedCard : null;
        var hint = panel.querySelector('[data-gbld-addon-hint]');
        var empty = panel.querySelector('[data-gbld-addon-empty]');
        var filterBlasters = state.grouped ? chosen : legacyChosen;
        state.dirty = false;
        state.groups = [];
        if (state.pool) state.cards.forEach(function (card) { if (card.parentNode !== state.pool) state.pool.appendChild(card); });
        if (state.groupRoot) clearNode(state.groupRoot);
        state.cards.forEach(function (card) { card.hidden = true; });

        if (!filterBlasters.length || !state.grouped) {
          var visibleCount = 0;
          state.cards.forEach(function (card) {
            var fits = filterBlasters.some(function (blaster) { return fitsCollection(card, blaster.collection); });
            var selected = productQuantity(card.getAttribute('data-product-id') || '') > 0;
            var visible = filterBlasters.length === 0
              ? card.getAttribute('data-universal') === 'true'
              : fits || selected;
            card.hidden = !visible;
            if (visible) visibleCount += 1;
          });
          if (hint) hint.hidden = filterBlasters.length > 0;
          if (empty) empty.hidden = filterBlasters.length === 0 || visibleCount > 0;
          restoreAddonFocus(focused, focusCard);
          return;
        }

        var groups = [];
        var byKey = new Map();
        var otherGroup = null;
        state.cards.forEach(function (card, cardIndex) {
          var indices = [];
          chosen.forEach(function (blaster, index) {
            if (fitsCollection(card, blaster.collection)) indices.push(index);
          });
          var selected = productQuantity(card.getAttribute('data-product-id') || '') > 0;
          if (!indices.length) {
            if (selected) {
              if (!otherGroup) {
                otherGroup = { other: true, indices: [], cards: [], order: cardIndex };
                groups.push(otherGroup);
              }
              otherGroup.cards.push(card);
            }
            return;
          }
          var key = indices.join(',');
          var group = byKey.get(key);
          if (!group) {
            group = { indices: indices, cards: [], order: cardIndex };
            byKey.set(key, group);
            groups.push(group);
          }
          group.cards.push(card);
        });
        groups.sort(function (left, right) {
          if (left.other !== right.other) return left.other ? 1 : -1;
          if (left.other) return left.order - right.order;
          var leftAll = chosen.length > 1 && left.indices.length === chosen.length;
          var rightAll = chosen.length > 1 && right.indices.length === chosen.length;
          if (leftAll !== rightAll) return leftAll ? -1 : 1;
          if (left.indices.length !== right.indices.length) return right.indices.length - left.indices.length;
          if (left.indices[0] !== right.indices[0]) return left.indices[0] - right.indices[0];
          return left.order - right.order;
        });

        groups.forEach(function (group) {
          var fragment = state.groupTemplate.content.cloneNode(true);
          var groupNode = fragment.querySelector('[data-gbld-group]');
          if (!groupNode) return;
          var title = groupNode.querySelector('[data-gbld-group-title]');
          var pictures = groupNode.querySelector('[data-gbld-group-pics]');
          var grid = groupNode.querySelector('[data-gbld-group-grid]');
          var groupBlasters = group.indices.map(function (index) { return chosen[index]; });
          if (group.other) {
            if (title) title.textContent = str('group_other');
          } else if (groupBlasters.length === chosen.length && chosen.length > 1) {
            if (title) title.textContent = str('group_all');
          } else if (groupBlasters.length === 1) {
            if (title) title.textContent = format('group_one', { name: groupBlasters[0].name });
          } else if (title) {
            title.textContent = format('group_some', { name: groupBlasters.map(function (blaster) { return blaster.name; }).join(' + ') });
          }
          var titleSize = title ? engine.groupTitleSize(title.textContent) : '';
          if (titleSize) title.setAttribute('data-gbld-size', titleSize);
          if (pictures && !group.other) {
            if (groupBlasters.length > 3) pictures.setAttribute('data-gbld-many', '');
            groupBlasters.forEach(function (blaster) {
              var image = documentRef.createElement('img');
              image.setAttribute('class', 'gbld-group__pic');
              image.setAttribute('alt', '');
              var groupImage = sizedImage(blaster.image, 180);
              if (groupImage) image.setAttribute('src', groupImage);
              pictures.appendChild(image);
            });
          }
          group.cards.forEach(function (card) {
            card.hidden = false;
            if (grid) grid.appendChild(card);
          });
          state.groupRoot.appendChild(groupNode);
          state.groups.push({ element: groupNode, set: groupBlasters, other: !!group.other });
        });
        scheduleGroupTitleFit(state);
        if (hint) hint.hidden = true;
        if (empty) empty.hidden = state.groups.length > 0;
        restoreAddonFocus(focused, focusCard);
      });
    }

    function renderSummary(result) {
      var count = root.querySelector('[data-gbld-count]');
      var badge = root.querySelector('[data-gbld-count-badge]');
      var empty = root.querySelector('[data-gbld-empty]');
      var total = root.querySelector('[data-gbld-total]');
      var totalWas = root.querySelector('[data-gbld-total-was]');
      var saving = root.querySelector('[data-gbld-saving]');
      var giftFact = giftUnlocked && giftId ? giftFactFor(giftId) : null;
      var hasRows = result.itemCount > 0 || mysteryGiftUnlocked || !!giftFact;
      if (summary) summary.classList.toggle('is-empty', !hasRows && !pendingRecovery);
      if (count) count.textContent = format(result.itemCount === 1 ? 'count_one' : 'count_many', { count: result.itemCount });
      if (badge) badge.textContent = String(result.itemCount);
      if (empty) empty.hidden = hasRows;
      if (total) total.textContent = formatter(result.total);
      if (totalWas) {
        totalWas.textContent = formatter(result.referenceTotal);
        totalWas.hidden = result.referenceTotal <= result.total;
      }
      if (saving) {
        saving.textContent = result.saving > 0 ? format('saving', { amount: formatter(result.saving) }) : '';
        saving.hidden = result.saving <= 0;
      }
      clearNode(itemsNode);
      var lines = result.lines.slice().sort(function (left, right) {
        var leftFact = factFor(left.id);
        var rightFact = factFor(right.id);
        var leftRank = leftFact && leftFact.eligible ? 0 : 1;
        var rightRank = rightFact && rightFact.eligible ? 0 : 1;
        return leftRank - rightRank;
      });
      lines.forEach(function (line) {
        var fact = factFor(line.id);
        if (!fact) return;
        var row = fillRow(fact, line.qty, line.unitFinal);
        if (row) itemsNode.appendChild(row);
      });
      if (mysteryGiftUnlocked) {
        var mysteryRow = fillGiftRow(mysteryGiftFact, 'mystery');
        if (mysteryRow) itemsNode.appendChild(mysteryRow);
      }
      if (giftFact) {
        var giftRow = fillGiftRow(giftFact);
        if (giftRow) itemsNode.appendChild(giftRow);
      }
      renderMessage(result);
      renderCartNote();
      renderShipping(result);
      renderGiftBar();
      if (submitButton) submitButton.disabled = busy || (!pendingRecovery && (result.itemCount === 0 || (giftUnlocked && !giftId)));
      var submitTotal = root.querySelector('[data-gbld-submit-total]');
      if (submitTotal && (!busy || pendingRecovery)) {
        submitTotal.textContent = !pendingRecovery && result.itemCount > 0 ? formatter(result.total) : '';
        submitTotal.hidden = !!pendingRecovery || result.itemCount === 0;
      }
    }

    function paintAll(result, productQuantities) {
      cards.forEach(function (card) { paintCard(card, result, productQuantities); });
      updateAddonFilter();
      var pickedEligible = result.pickedEligibleCount;
      var meterCurrentIndex = engine.tierIndexForProgress(result.eligibleCount, pickedEligible, tiers);
      // One entry per eligible unit: cart items first (no picture), then the picks in order of first selection.
      var units = [];
      for (var cartUnit = 0; cartUnit < cartEligibleQty; cartUnit += 1) units.push({ cart: true, image: '' });
      selections.forEach(function (qty, id) {
        var fact = factFor(id);
        if (!fact || !fact.eligible) return;
        for (var unitIndex = 0; unitIndex < qty; unitIndex += 1) units.push({ cart: false, image: fact.image });
      });
      var segments = root.querySelectorAll('[data-gbld-seg]');
      var lastSegment = -1;
      Array.prototype.forEach.call(segments, function (segment) {
        if (segment.hidden) return;
        lastSegment = Math.max(lastSegment, readInteger(segment.getAttribute('data-gbld-seg'), -1));
      });
      Array.prototype.forEach.call(segments, function (segment) {
        var index = readInteger(segment.getAttribute('data-gbld-seg'), -1);
        var tier = tiers[index];
        var progress = engine.tierProgressFor(index, tiers, result.eligibleCount, pickedEligible);
        var reached = progress.reached;
        segment.classList.toggle('is-reached', reached);
        segment.classList.toggle('is-current', reached && index === meterCurrentIndex);
        var selectedGiftFact = giftUnlocked && giftId ? giftFactFor(giftId) : null;
        var unit = engine.meterSlotForTier(tier, units, {
          mysteryUnlocked: mysteryGiftUnlocked,
          mysteryImage: mysteryGiftFact.image,
          giftUnlocked: giftUnlocked,
          giftImage: selectedGiftFact ? selectedGiftFact.image : ''
        });
        segment.classList.toggle('is-filled', !!unit);
        segment.classList.toggle('is-cart', !!unit && unit.cart);
        var slotImage = segment.querySelector('[data-gbld-slot-img]');
        if (slotImage) {
          var slotSrc = unit ? sizedImage(unit.image, 180) : '';
          if (slotSrc) {
            if (slotImage.getAttribute('src') !== slotSrc) slotImage.setAttribute('src', slotSrc);
            slotImage.hidden = false;
          } else {
            slotImage.removeAttribute('src');
            slotImage.hidden = true;
          }
        }
        var slotMore = segment.querySelector('[data-gbld-slot-more]');
        if (slotMore) {
          var progressCount = engine.tierProgressCount(tier, result.eligibleCount, pickedEligible);
          var extra = tier && index === lastSegment ? progressCount - Number(tier.qty) : 0;
          slotMore.textContent = extra > 0 ? '+' + extra : '';
          slotMore.hidden = extra <= 0;
        }
      });
      renderSummary(result);
      if (quickViewOpen) updateQuickViewContent();
    }

    function render(announce) {
      var productQuantities = buildProductQuantities();
      var result = currentPrice();
      paintAll(result, productQuantities);
      if (giftReturnPending) {
        giftReturnPending = false;
        var returnTarget = giftBar && !giftBar.hidden ? giftBar : root.querySelector('[data-gbld-summary-toggle]');
        if (returnTarget) returnTarget.focus();
      }
      if (lastTierIndex === null) lastTierIndex = result.tierIndex;
      else if (result.tierIndex !== lastTierIndex) {
        lastTierIndex = result.tierIndex;
        if (announce) emit('gbld:tier', result);
      }
      if (announce) emit('gbld:change', result);
      return result;
    }

    function persist() {
      // A non-durable pending receipt must not recreate saved picks that a reload could resend.
      if ((activeSubmit && activeSubmit.markerDurable === false && !activeSubmit.finalized && !activeSubmit.cancelled) ||
          (pendingRecovery && pendingRecovery.nonPersistent && !pendingRecovery.accepted && !pendingRecovery.noPost)) return false;
      try {
        if (!global.sessionStorage) return false;
        if (!selections.size && !giftId) {
          global.sessionStorage.removeItem(storageKey);
          return global.sessionStorage.getItem(storageKey) == null;
        }
        var selected = {};
        selections.forEach(function (qty, id) { selected[id] = qty; });
        var text = JSON.stringify({ sel: selected, gift: giftId || null });
        global.sessionStorage.setItem(storageKey, text);
        return global.sessionStorage.getItem(storageKey) === text;
      } catch (error) {}
      return false;
    }

    function restore() {
      try {
        if (!global.sessionStorage) return;
        var raw = global.sessionStorage.getItem(storageKey);
        if (!raw) return;
        var saved = JSON.parse(raw);
        if (!saved || typeof saved !== 'object' || Array.isArray(saved)) return;
        var selected = saved.sel && typeof saved.sel === 'object' && !Array.isArray(saved.sel) ? saved.sel : saved;
        Object.keys(selected).forEach(function (id) {
          var quantity = readInteger(selected[id], 0);
          if (quantity > 0 && variantFacts.has(String(id))) selections.set(String(id), Math.min(maxQty, quantity));
        });
        if (giftQty > 0 && typeof saved.gift === 'string' && giftFactFor(saved.gift)) giftId = saved.gift;
      } catch (error) {}
    }

    function setQuantity(id, quantity) {
      var fact = factFor(id);
      if (!fact) return false;
      var key = String(id);
      var next = Math.max(0, Math.min(maxQty, readInteger(quantity, 0)));
      if (activeSubmit && activeSubmit.lowest.has(key)) {
        activeSubmit.lowest.set(key, Math.min(activeSubmit.lowest.get(key), next));
      }
      if (next === 0) selections.delete(key);
      else selections.set(key, next);
      // Only a deliberate removal of every remaining pick clears an unresolved recovery.
      if (pendingRecovery && selections.size === 0) {
        var pending = pendingRecovery;
        pendingRecovery = null;
        var attempt = activeSubmit;
        activeSubmit = null;
        if (attempt) {
          attempt.cancelled = true;
          clearAttemptTimers(attempt);
        }
        clearPendingMarker(pending);
        setBusy(false);
        setError('');
      }
      persist();
      render(true);
      return true;
    }

    function changeQuantity(id, delta) {
      return setQuantity(id, (selections.get(String(id)) || 0) + delta);
    }

    function updateTabs(activeTab, scrollPage) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-gbld-tab]'));
      var panels = Array.prototype.slice.call(root.querySelectorAll('[data-gbld-panel]'));
      var activatingPanel = panels.find(function (panel) {
        return panel.getAttribute('data-gbld-panel') === activeTab.getAttribute('data-gbld-tab');
      });
      var activatingAddonState = addonPanelStates.find(function (state) { return state.panel === activatingPanel; });
      if (activatingAddonState && activatingAddonState.grouped && activatingAddonState.dirty) {
        updateAddonFilter(activatingAddonState);
      }
      tabs.forEach(function (tab) {
        var active = tab === activeTab;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');
      });
      panels.forEach(function (panel) {
        var active = panel.getAttribute('data-gbld-panel') === activeTab.getAttribute('data-gbld-tab');
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
      if (activatingAddonState) scheduleGroupTitleFit(activatingAddonState);
      tabPill.style.transform = 'translateX(' + activeTab.offsetLeft + 'px)';
      tabPill.style.width = String(activeTab.offsetWidth) + 'px';
      var tabRect = activeTab.getBoundingClientRect();
      var barRect = tabsNode.getBoundingClientRect();
      if (tabRect.left < barRect.left) tabsNode.scrollLeft -= barRect.left - tabRect.left;
      else if (tabRect.right > barRect.right) tabsNode.scrollLeft += tabRect.right - barRect.right;
      if (scrollPage && (barRect.bottom <= 0 || barRect.top >= global.innerHeight)) {
        var top = global.pageYOffset + barRect.top - 96;
        var smooth = !prefersReducedMotion();
        global.scrollTo({ top: Math.max(0, top), behavior: smooth ? 'smooth' : 'auto' });
      }
    }

    function prefersReducedMotion() {
      try { return !!(global.matchMedia && global.matchMedia('(prefers-reduced-motion: reduce)').matches); }
      catch (error) { return false; }
    }

    function setSummaryOpen(open, returnFocus) {
      if (global.innerWidth >= 1000) open = false;
      summaryOpen = !!open;
      if (summary) summary.classList.toggle('is-open', summaryOpen);
      if (backdrop) backdrop.hidden = !summaryOpen;
      var toggle = root.querySelector('[data-gbld-summary-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', summaryOpen ? 'true' : 'false');
      syncLock();
      if (summaryOpen) {
        var closeButton = root.querySelector('[data-gbld-summary-close]');
        if (closeButton) closeButton.focus();
      } else if (returnFocus && toggle) toggle.focus();
    }

    function openGiftDialog(opener) {
      if (!giftDialog || !giftUnlocked || giftQty <= 0) return;
      buildGiftOptions();
      var title = giftDialog.querySelector('.gbld-gift__title');
      if (title) title.textContent = str('gift_title');
      syncGiftOptions();
      giftDialogOpener = opener || null;
      giftDialog.hidden = false;
      giftDialog.classList.add('is-open');
      giftDialogOpen = true;
      syncLock();
      var close = giftDialog.querySelector('[data-gbld-gift-close]');
      if (close) close.focus();
    }

    function closeGiftDialog(returnFocus) {
      if (!giftDialogOpen) return;
      giftDialogOpen = false;
      if (giftDialog) {
        giftDialog.classList.remove('is-open');
        giftDialog.hidden = true;
      }
      syncLock();
      var opener = giftDialogOpener;
      giftDialogOpener = null;
      if (giftCloseTimer) {
        global.clearTimeout(giftCloseTimer);
        giftCloseTimer = null;
      }
      if (returnFocus) {
        if (opener && opener.isConnected && !opener.hidden) opener.focus();
        else if (giftBar && !giftBar.hidden) giftBar.focus();
        else {
          var toggle = root.querySelector('[data-gbld-summary-toggle]');
          if (toggle) toggle.focus();
        }
      }
    }

    function closeGiftAfterPick() {
      if (giftCloseTimer) global.clearTimeout(giftCloseTimer);
      giftCloseTimer = global.setTimeout(function () {
        giftCloseTimer = null;
        closeGiftDialog(true);
      }, 500);
    }

    function focusables(container) {
      if (!container) return [];
      return Array.prototype.slice.call(container.querySelectorAll('button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
        .filter(function (node) { return !node.hidden && node.getAttribute('aria-hidden') !== 'true' && node.getClientRects().length > 0; });
    }

    function scrollBelowHeader(target) {
      if (!target || !target.getBoundingClientRect) return;
      var rect = target.getBoundingClientRect();
      var top = (global.pageYOffset || 0) + rect.top - 96;
      global.scrollTo({ top: Math.max(0, top), behavior: prefersReducedMotion() ? 'auto' : 'smooth' });
    }

    function showGearFor(button) {
      var card = button.closest('[data-gbld-card]');
      if (!card) return;
      var productId = card.getAttribute('data-product-id') || '';
      var addonPanel = root.querySelector('[data-gbld-panel][data-gbld-kind="addons"]');
      var addonTab = null;
      if (addonPanel) {
        var panelId = addonPanel.getAttribute('data-gbld-panel');
        addonTab = Array.prototype.slice.call(root.querySelectorAll('[data-gbld-tab]')).find(function (tab) {
          return tab.getAttribute('data-gbld-tab') === panelId;
        }) || null;
      }
      if (addonTab) {
        updateTabs(addonTab, false);
        addonTab.focus();
      }
      var targetAddonState = addonPanelStates.find(function (state) { return state.panel === addonPanel; }) ||
        addonPanelStates.find(function (state) { return state.grouped; });
      if (targetAddonState && (!addonTab || targetAddonState.dirty)) updateAddonFilter(targetAddonState);
      var targetGroup = null;
      addonPanelStates.some(function (state) {
        targetGroup = state.groups.find(function (group) {
          return group.set.some(function (blaster) { return blaster.productId === productId; });
        }) || null;
        return !!targetGroup;
      });
      if (targetGroup) {
        scrollBelowHeader(targetGroup.element);
        targetGroup.element.classList.add('is-flash');
        var flashTimer = global.setTimeout(function () {
          targetGroup.element.classList.remove('is-flash');
          groupFlashTimers = groupFlashTimers.filter(function (timer) { return timer !== flashTimer; });
        }, 1200);
        groupFlashTimers.push(flashTimer);
        return;
      }
      var collection = card.getAttribute('data-addon-coll') || '';
      var fallback = addonCards.find(function (addon) { return !addon.hidden && fitsCollection(addon, collection); });
      if (fallback) scrollBelowHeader(fallback);
    }

    function addWidthQuery(source) {
      if (!source) return '';
      try {
        var url = new global.URL(source, global.location.href);
        url.searchParams.set('width', '720');
        return url.toString();
      } catch (error) {
        return source + (source.indexOf('?') === -1 ? '?' : '&') + 'width=720';
      }
    }

    function quickViewDetails(card) {
      var handle = card && card.getAttribute('data-handle') || '';
      return productDetails[handle] || {};
    }

    function quickViewSlides() {
      return quickViewGallery ? Array.prototype.slice.call(quickViewGallery.querySelectorAll('[data-gbld-qv-slide]')) : [];
    }

    function updateQuickViewGalleryControls() {
      var slides = quickViewSlides();
      if (quickViewGalleryControls) quickViewGalleryControls.hidden = slides.length <= 1;
      if (quickViewGalleryCount) quickViewGalleryCount.textContent = slides.length ? String(activeGalleryIndex + 1) + ' / ' + String(slides.length) : '';
      var previous = quickView && quickView.querySelector('[data-gbld-qv-prev]');
      var next = quickView && quickView.querySelector('[data-gbld-qv-next]');
      if (previous) previous.disabled = slides.length <= 1 || activeGalleryIndex <= 0;
      if (next) next.disabled = slides.length <= 1 || activeGalleryIndex >= slides.length - 1;
    }

    function stopQuickViewDemo() {
      var video = activeDemoVideo;
      var slide = activeDemoSlide;
      activeDemoVideo = null;
      activeDemoSlide = null;
      if (video) engine.stopVideoElement(video);
      if (slide) {
        slide.classList.remove('gbld-qv__slide--playing');
        var playButton = slide.querySelector('[data-gbld-demo-play]');
        var error = slide.querySelector('[data-gbld-demo-error]');
        if (playButton) playButton.hidden = false;
        if (error) error.hidden = true;
      }
    }

    function setQuickViewGalleryIndex(index, scrollToSlide) {
      var slides = quickViewSlides();
      if (!slides.length) {
        activeGalleryIndex = 0;
        updateQuickViewGalleryControls();
        return;
      }
      var nextIndex = Math.max(0, Math.min(slides.length - 1, Number(index) || 0));
      if (activeDemoVideo && slides[nextIndex] !== activeDemoSlide) stopQuickViewDemo();
      activeGalleryIndex = nextIndex;
      updateQuickViewGalleryControls();
      if (scrollToSlide && quickViewGallery) {
        var target = slides[nextIndex];
        var behavior = prefersReducedMotion() ? 'auto' : 'smooth';
        try {
          if (typeof quickViewGallery.scrollTo === 'function') quickViewGallery.scrollTo({ left: target.offsetLeft, behavior: behavior });
          else quickViewGallery.scrollLeft = target.offsetLeft;
        } catch (error) { quickViewGallery.scrollLeft = target.offsetLeft; }
      }
    }

    function syncQuickViewGalleryIndex() {
      qvGalleryTimer = null;
      var slides = quickViewSlides();
      if (!slides.length || !quickViewGallery) return;
      var left = Number(quickViewGallery.scrollLeft) || 0;
      var nearest = 0;
      var distance = Infinity;
      slides.forEach(function (slide, index) {
        var nextDistance = Math.abs((Number(slide.offsetLeft) || 0) - left);
        if (nextDistance < distance) {
          nearest = index;
          distance = nextDistance;
        }
      });
      setQuickViewGalleryIndex(nearest, false);
    }

    function addQuickViewImage(source, alt, selectedGearPhoto) {
      var safeSource = engine.safeShopifyMediaUrl(source);
      if (!safeSource || !quickViewGallery) return '';
      var slide = documentRef.createElement('div');
      slide.setAttribute('class', 'gbld-qv__slide' + (selectedGearPhoto ? ' gbld-qv__slide--contain' : ''));
      slide.setAttribute('data-gbld-qv-slide', '');
      slide.setAttribute('data-gbld-qv-kind', 'image');
      var image = documentRef.createElement('img');
      image.setAttribute('class', 'gbld-qv__slide-img');
      image.setAttribute('src', addWidthQuery(safeSource));
      image.setAttribute('alt', alt || '');
      image.setAttribute('loading', 'lazy');
      image.setAttribute('decoding', 'async');
      slide.appendChild(image);
      quickViewGallery.appendChild(slide);
      return safeSource.split('?')[0];
    }

    function addQuickViewVideo(videoInfo, posterSource, title) {
      var source = engine.safeShopifyMediaUrl(videoInfo && videoInfo.url);
      if (!source || !quickViewGallery) return false;
      var poster = engine.safeShopifyMediaUrl(videoInfo.poster) || engine.safeShopifyMediaUrl(posterSource);
      if (!poster) return false;
      var slide = documentRef.createElement('div');
      slide.setAttribute('class', 'gbld-qv__slide gbld-qv__slide--video');
      slide.setAttribute('data-gbld-qv-slide', '');
      slide.setAttribute('data-gbld-qv-kind', 'video');
      var video = documentRef.createElement('video');
      video.muted = true;
      video.playsInline = true;
      video.setAttribute('preload', 'none');
      video.setAttribute('muted', '');
      video.setAttribute('playsinline', '');
      video.setAttribute('poster', poster);
      video.setAttribute('data-gbld-demo-src', source);
      video.setAttribute('aria-label', title + ' product demo');
      var playButton = documentRef.createElement('button');
      playButton.setAttribute('type', 'button');
      playButton.setAttribute('class', 'gbld-qv__play');
      playButton.setAttribute('data-gbld-demo-play', '');
      playButton.setAttribute('aria-label', 'Play demo for ' + title);
      playButton.textContent = 'Play demo';
      var error = documentRef.createElement('p');
      error.setAttribute('class', 'gbld-qv__video-error');
      error.setAttribute('data-gbld-demo-error', '');
      error.hidden = true;
      error.setAttribute('role', 'status');
      error.textContent = 'Demo could not play. Tap to try again.';
      slide.appendChild(video);
      slide.appendChild(playButton);
      slide.appendChild(error);
      quickViewGallery.appendChild(slide);
      return true;
    }

    function playQuickViewDemo(button) {
      var slide = button && button.closest('[data-gbld-qv-slide]');
      var video = slide && slide.querySelector('video[data-gbld-demo-src]');
      if (!slide || !video) return;
      var source = video.getAttribute('data-gbld-demo-src') || '';
      var poster = video.getAttribute('poster') || '';
      var error = slide.querySelector('[data-gbld-demo-error]');
      stopQuickViewDemo();
      activeDemoVideo = video;
      activeDemoSlide = slide;
      if (error) error.hidden = true;
      if (video.addEventListener) video.addEventListener('error', function () {
        if (activeDemoVideo === video) stopQuickViewDemo();
        if (error) error.hidden = false;
      }, { once: true });
      var playResult = engine.startVideoElement(video, source, poster);
      if (playResult === false) {
        stopQuickViewDemo();
        if (error) error.hidden = false;
        return;
      }
      function markPlaying() {
        if (activeDemoVideo !== video) return;
        slide.classList.add('gbld-qv__slide--playing');
        button.hidden = true;
        if (error) error.hidden = true;
      }
      if (video.addEventListener) video.addEventListener('playing', markPlaying, { once: true });
      if (playResult && typeof playResult.then === 'function') {
        playResult.then(markPlaying).catch(function () {
          if (activeDemoVideo === video) stopQuickViewDemo();
          if (error) error.hidden = false;
        });
      }
    }

    function renderQuickViewGallery(card) {
      if (!quickViewGallery || !card) return;
      stopQuickViewDemo();
      clearNode(quickViewGallery);
      activeGalleryIndex = 0;
      var details = quickViewDetails(card);
      var hero = card.querySelector('[data-gbld-img]');
      var heroSource = hero && (hero.currentSrc || hero.getAttribute('src')) || '';
      var selectedNode = card.querySelector('[data-gbld-variant].is-active') || card.querySelector('[data-gbld-variant]');
      var selectedDisplay = selectedNode ? engine.variantDisplay(
        card.getAttribute('data-handle') || '', selectedNode.getAttribute('data-family') || '',
        card.getAttribute('data-title') || '', card.getAttribute('data-short') || '', selectedNode.getAttribute('data-gift-title') || ''
      ) : engine.variantDisplay(card.getAttribute('data-handle') || '', '', card.getAttribute('data-title') || '', card.getAttribute('data-short') || '');
      var normalRavenFamily = card.getAttribute('data-handle') === 'raven' && selectedDisplay.family === 'normal';
      var heroAlt = hero && hero.getAttribute('alt') || selectedDisplay.title || '';
      var imageKeys = new Set();
      var selectedGearPhoto = card.getAttribute('data-handle') === 'tactical-light-red-laser-combo';
      var heroKey = addQuickViewImage(heroSource, heroAlt, selectedGearPhoto);
      if (heroKey) imageKeys.add(heroKey);
      var heroSlide = heroKey ? quickViewSlides()[0] : null;
      var videoRows = normalRavenFamily && Array.isArray(details.normalVariantVideos)
        ? details.normalVariantVideos
        : details.videos;
      var videos = (Array.isArray(videoRows) ? videoRows : []).filter(function (video) {
        return !!engine.safeShopifyMediaUrl(video && video.url) &&
          !!(engine.safeShopifyMediaUrl(video && video.poster) || engine.safeShopifyMediaUrl(heroSource));
      });
      var firstVideoIndex = -1;
      if (videos.length && addQuickViewVideo(videos[0], heroSource, selectedDisplay.title || 'Product')) {
        firstVideoIndex = quickViewSlides().length - 1;
      }
      (!normalRavenFamily && Array.isArray(details.images) ? details.images : []).forEach(function (image) {
        var source = image && typeof image.url === 'string' ? image.url : '';
        var safe = engine.safeShopifyMediaUrl(source);
        var key = safe ? safe.split('?')[0] : '';
        if (!safe || !key || imageKeys.has(key)) return;
        imageKeys.add(key);
        addQuickViewImage(safe, image.alt || heroAlt, false);
      });
      videos.slice(1).forEach(function (video) { addQuickViewVideo(video, heroSource, selectedDisplay.title || 'Product'); });
      if (heroSlide && firstVideoIndex > 0) {
        var jump = documentRef.createElement('button');
        jump.setAttribute('type', 'button');
        jump.setAttribute('class', 'gbld-qv__demo-jump');
        jump.setAttribute('data-gbld-demo-jump', '');
        jump.setAttribute('data-gbld-demo-index', String(firstVideoIndex));
        jump.setAttribute('aria-label', 'Jump to the product demo');
        jump.textContent = '▶ Demo';
        heroSlide.appendChild(jump);
      }
      if (!quickViewSlides().length && heroSource) addQuickViewImage(heroSource, heroAlt, selectedGearPhoto);
      updateQuickViewGalleryControls();
    }

    function renderQuickViewBullets(card) {
      var list = quickView && quickView.querySelector('[data-gbld-qv-desc]');
      if (!list) return;
      clearNode(list);
      var bullets = quickViewDetails(card).bullets;
      var rendered = 0;
      (Array.isArray(bullets) ? bullets : []).forEach(function (text) {
        var value = typeof text === 'string' ? text.trim() : '';
        var words = value ? value.split(/\s+/).length : 0;
        if (words < 3 || words > 7 || rendered >= 3) return;
        var item = documentRef.createElement('li');
        item.textContent = value;
        list.appendChild(item);
        rendered += 1;
      });
      list.hidden = rendered === 0;
    }

    function updateQuickViewContent() {
      if (!quickView || !quickViewCard) return;
      var titleNode = quickView.querySelector('[data-gbld-qv-title]');
      var priceNode = quickView.querySelector('[data-gbld-qv-price]');
      var variantsNode = quickView.querySelector('[data-gbld-qv-variants]');
      var action = quickView.querySelector('[data-gbld-qv-action]');
      if (titleNode) {
        var selected = activeVariant(quickViewCard);
        var display = selected ? engine.variantDisplay(
          quickViewCard.getAttribute('data-handle') || '', selected.getAttribute('data-family') || '',
          quickViewCard.getAttribute('data-title') || '', quickViewCard.getAttribute('data-short') || '', selected.getAttribute('data-gift-title') || ''
        ) : engine.variantDisplay(quickViewCard.getAttribute('data-handle') || '', '', quickViewCard.getAttribute('data-title') || '', quickViewCard.getAttribute('data-short') || '');
        titleNode.textContent = display.title;
      }
      if (priceNode) {
        clearNode(priceNode);
        var cardPrice = quickViewCard.querySelector('[data-gbld-price]');
        if (cardPrice) {
          Array.prototype.forEach.call(cardPrice.childNodes, function (child) { priceNode.appendChild(child.cloneNode(true)); });
        }
      }
      if (variantsNode) {
        clearNode(variantsNode);
        Array.prototype.forEach.call(quickViewCard.querySelectorAll('[data-gbld-variant]'), function (variant) {
          variantsNode.appendChild(variant.cloneNode(true));
        });
      }
      if (action) {
        var id = activeId(quickViewCard);
        action.textContent = selections.has(id) ? str('qv_remove') : str('qv_add');
      }
      var link = quickView.querySelector('[data-gbld-qv-link]');
      if (link) link.setAttribute('href', quickViewCard.getAttribute('data-url') || '');
    }

    function openQuickView(card, opener) {
      if (!quickView) return;
      stopQuickViewDemo();
      quickViewCard = card;
      quickViewOpener = opener || null;
      renderQuickViewGallery(card);
      renderQuickViewBullets(card);
      updateQuickViewContent();
      quickView.hidden = false;
      quickView.classList.add('is-open');
      quickViewOpen = true;
      syncLock();
      var close = quickView.querySelector('[data-gbld-qv-close]');
      if (close) close.focus();
    }

    function closeQuickView(returnFocus) {
      if (!quickViewOpen) return;
      stopQuickViewDemo();
      quickViewOpen = false;
      if (quickView) {
        quickView.classList.remove('is-open');
        quickView.hidden = true;
      }
      syncLock();
      var opener = quickViewOpener;
      quickViewCard = null;
      quickViewOpener = null;
      if (qvCloseTimer) {
        global.clearTimeout(qvCloseTimer);
        qvCloseTimer = null;
      }
      if (returnFocus && opener && opener.isConnected) opener.focus();
    }

    function closeAllSheets() {
      closeGiftDialog(false);
      closeQuickView(false);
      setSummaryOpen(false, false);
    }

    function handleVariant(node) {
      var card = node.closest('[data-gbld-card]') || quickViewCard;
      if (!card) return;
      var id = String(node.getAttribute('data-id') || '');
      if (!id) return;
      activateVariant(card, id);
      var result = render(true);
      if (quickViewOpen) {
        stopQuickViewDemo();
        updateQuickViewContent();
        renderQuickViewGallery(card);
      }
      return result;
    }

    function hasGiftLine(state) {
      return hasBosGift(state) || engine.hasTaggedMysteryGift(state, mysteryGiftId);
    }

    function applyCartState(state) {
      if (!alive) return null;
      var nextState = state || null;
      var nextEligible = eligibleQtyInCart(nextState, tierCollectionSet);
      var nextTotal = Number(nextState && nextState.total_price) || 0;
      var nextCount = Number(nextState && nextState.item_count) || 0;
      var changed = nextEligible !== cartEligibleQty || nextTotal !== cartTotal || hasGiftLine(nextState) !== hasGiftLine(cartStateData);
      lastCart = nextState;
      lastCartCount = nextCount;
      cartEligibleQty = nextEligible;
      cartTotal = nextTotal;
      cartStateData = nextState;
      if (changed) render(true);
      return nextState;
    }

    function applyEmptyCart() {
      if (!alive) return null;
      var changed = cartEligibleQty !== 0 || cartTotal !== 0 || hasGiftLine(cartStateData);
      lastCart = null;
      lastCartCount = 0;
      cartEligibleQty = 0;
      cartTotal = 0;
      cartStateData = null;
      if (changed) render(true);
      return null;
    }

    // A request that never answers must not keep the shopper waiting: after the limit the caller's fallback runs.
    function withTimeout(promise, ms) {
      return new Promise(function (resolve, reject) {
        var timer = global.setTimeout(function () { reject(new Error('Timed out')); }, ms);
        Promise.resolve(promise).then(function (value) {
          global.clearTimeout(timer);
          resolve(value);
        }, function (error) {
          global.clearTimeout(timer);
          reject(error);
        });
      });
    }

    function readCartStateSection(fresh, signal) {
      if (typeof global.fetch !== 'function' || typeof global.DOMParser !== 'function') {
        return Promise.reject(new Error('Cart state unavailable'));
      }
      var requestId = ++cartRequestId;
      var base = root.getAttribute('data-root-url') || '/';
      var url = base + (base.indexOf('?') === -1 ? '?' : '&') + 'section_id=gbld-cart-state';
      var request = { headers: { Accept: 'text/html' } };
      if (fresh) request.cache = 'no-store';
      if (signal) request.signal = signal;
      return global.fetch(url, request).then(function (response) {
        if (!response.ok) throw new Error('Cart state unavailable');
        return response.text();
      }).then(function (html) {
        // An answer that was overtaken (or arrives after cleanup) is dropped, never applied as an empty cart.
        if (requestId !== cartRequestId || !alive) throw new Error('Cart state stale');
        var parsed = new global.DOMParser().parseFromString(html, 'text/html');
        var stateNode = parsed.querySelector('[data-gbld-cart-state]');
        if (!stateNode) throw new Error('Cart state missing');
        return JSON.parse(stateNode.textContent || '{}');
      });
    }

    function updateCartState(snapshot) {
      var hasItems = !!(snapshot && ((Number(snapshot.item_count) || 0) > 0 || (Array.isArray(snapshot.items) && snapshot.items.length > 0)));
      if (!hasItems) return Promise.resolve(applyCartState(snapshot));
      return readCartStateSection().then(applyCartState);
    }

    function ensureFreshCart(force, snapshot, hasSnapshot) {
      force = !!force;
      hasSnapshot = !!hasSnapshot;
      if (force || hasSnapshot) cartFresh = false;
      if (cartFresh && !force && !hasSnapshot) return Promise.resolve(cartStateData);
      if (cartReading) {
        if (force || hasSnapshot) {
          cartNeedsAnotherRead = true;
          cartQueuedForce = cartQueuedForce || force;
          if (hasSnapshot) {
            cartQueuedSnapshot = snapshot;
            cartQueuedSnapshotSet = true;
          }
        }
        return cartReading;
      }

      function startReading(readForce, providedSnapshot, providedSnapshotSet) {
        cartNeedsAnotherRead = false;
        cartQueuedForce = false;
        cartQueuedSnapshot = undefined;
        cartQueuedSnapshotSet = false;
        var resolveCurrentReading;
        var currentReading = new Promise(function (resolve) { resolveCurrentReading = resolve; });
        cartReading = currentReading;
        var reading;
        try {
          if (providedSnapshotSet) reading = updateCartState(providedSnapshot);
          else {
            var api = global.GBCart;
            if (api && typeof api.readCart === 'function') {
              reading = Promise.resolve(readForce ? api.readCart(true) : api.readCart()).then(updateCartState);
            } else reading = readCartStateSection().then(applyCartState);
          }
        } catch (error) { reading = Promise.reject(error); }
        var settled = withTimeout(reading, 5000).catch(function () {
          try { return applyEmptyCart(); }
          catch (error) { return null; }
        });
        settled.then(function (state) {
          if (!alive) {
            cartReading = null;
            resolveCurrentReading(null);
            return null;
          }
          if (cartNeedsAnotherRead) {
            var nextSnapshot = cartQueuedSnapshot;
            var nextSnapshotSet = cartQueuedSnapshotSet;
            var nextForce = cartQueuedForce;
            cartReading = null;
            startReading(nextForce, nextSnapshot, nextSnapshotSet).then(resolveCurrentReading, function () { resolveCurrentReading(null); });
            return null;
          }
          cartFresh = true;
          cartReading = null;
          resolveCurrentReading(state);
          return state;
        });
        return currentReading;
      }

      return startReading(force, snapshot, hasSnapshot);
    }

    function refreshCartAwareness(force) {
      return ensureFreshCart(!!force);
    }

    function getPendingMarker() {
      var marker = global.__gbldPendingAdd || null;
      try {
        var raw = global.sessionStorage && global.sessionStorage.getItem(pendingMarkerKey);
        if (raw) {
          try {
            var parsed = JSON.parse(raw);
            marker = parsed && typeof parsed.token === 'string' ? parsed : { token: 'unverified' };
          } catch (error) { marker = { token: 'unverified' }; }
        }
      } catch (error) {}
      return marker;
    }

    function storedSelectionMayRestore() {
      try {
        if (!global.sessionStorage) return false;
        var raw = global.sessionStorage.getItem(storageKey);
        if (!raw) return false;
        var saved = JSON.parse(raw);
        if (!saved || typeof saved !== 'object' || Array.isArray(saved)) return false;
        var selected = saved.sel && typeof saved.sel === 'object' && !Array.isArray(saved.sel) ? saved.sel : saved;
        return Object.keys(selected).some(function (id) {
          return readInteger(selected[id], 0) > 0 && variantFacts.has(String(id));
        });
      } catch (error) { return false; } // The existing restore also cannot restore unreadable storage.
    }

    function discardStaleStoredPicks() {
      if (!storedSelectionMayRestore()) return true;
      try {
        global.sessionStorage.removeItem(storageKey);
        return global.sessionStorage.getItem(storageKey) == null;
      } catch (error) { return false; }
    }

    function recordPending(attempt) {
      var marker = { v: 1, token: attempt.token };
      global.__gbldPendingAdd = marker;
      attempt.markerDurable = false;
      for (var pass = 0; pass < 2; pass += 1) {
        // Removing our stale saved picks can free room for the marker; retry once.
        if (pass === 1 && !discardStaleStoredPicks()) return false;
        try {
          if (global.sessionStorage) {
            var text = JSON.stringify(marker);
            global.sessionStorage.setItem(pendingMarkerKey, text);
            if (global.sessionStorage.getItem(pendingMarkerKey) === text) {
              attempt.markerDurable = true;
              return true;
            }
          }
        } catch (error) {}
      }
      // No restorable picks remain. Until this attempt is proven, persist keeps edits in memory.
      marker.nonPersistent = true;
      return true;
    }

    function clearPendingMarker(attempt) {
      var marker = getPendingMarker();
      if (!marker || !attempt || marker.token !== attempt.token) return;
      global.__gbldPendingAdd = null;
      try {
        if (global.sessionStorage) global.sessionStorage.removeItem(pendingMarkerKey);
      } catch (error) {}
    }

    function restorePending() {
      var marker = getPendingMarker();
      if (!marker) return false;
      pendingRecovery = marker;
      setBusy(false);
      setError('Check your cart. Items may already be there.');
      return true;
    }

    function attemptIsActive(attempt) {
      return !!(alive && attempt && activeSubmit === attempt && !attempt.cancelled && !attempt.finalized);
    }

    function clearAttemptTimers(attempt) {
      if (!attempt) return;
      ['deadlineTimer', 'retryTimer', 'recoveryTimer'].forEach(function (key) {
        if (attempt[key] != null) global.clearTimeout(attempt[key]);
        attempt[key] = null;
      });
      if (attempt.cancelAdd) {
        var cancelAdd = attempt.cancelAdd;
        attempt.cancelAdd = null;
        cancelAdd();
      }
      if (attempt.cancelRecovery) {
        var cancelRecovery = attempt.cancelRecovery;
        attempt.cancelRecovery = null;
        cancelRecovery();
      }
      [attempt.controller, attempt.recoveryController].forEach(function (controller) {
        if (controller) {
          try { controller.abort(); } catch (error) {}
        }
      });
    }

    function readUnknownCart(attempt) {
      return new Promise(function (resolve) {
        var finished = false;
        try {
          if (typeof global.AbortController === 'function') attempt.recoveryController = new global.AbortController();
        } catch (error) {}
        function done(state) {
          if (finished) return;
          finished = true;
          if (attempt.recoveryTimer != null) global.clearTimeout(attempt.recoveryTimer);
          attempt.recoveryTimer = null;
          attempt.cancelRecovery = null;
          resolve(state);
        }
        attempt.cancelRecovery = function () { done(null); };
        attempt.recoveryTimer = global.setTimeout(function () {
          done(null);
          if (attempt.recoveryController) {
            try { attempt.recoveryController.abort(); } catch (error) {}
          }
        }, 5000);
        var reading;
        try {
          reading = readCartStateSection(true, attempt.recoveryController && attempt.recoveryController.signal);
        } catch (error) { reading = Promise.reject(error); }
        Promise.resolve(reading).then(done, function () { done(null); });
      });
    }

    function beginUnknownRecovery(attempt) {
      if (!attemptIsActive(attempt)) return Promise.resolve(null);
      if (attempt.recoveryPromise) return attempt.recoveryPromise;
      pendingRecovery = { v: 1, token: attempt.token, nonPersistent: !attempt.markerDurable };
      var message = 'Check your cart. Items may already be there.';
      setBusy(true);
      setError(message);
      render(true);
      emit('gbld:error', { message: message });
      // This section lacks properties/selling-plan identity. It can refresh display,
      // but neither a matching variant total nor no delta proves this attempt absent.
      attempt.recoveryPromise = readUnknownCart(attempt).then(function (state) {
        if (!attemptIsActive(attempt)) return null;
        if (state) {
          try { applyCartState(state); } catch (error) {}
        }
        setBusy(false);
        render(true);
        setError(message);
        return state;
      });
      return attempt.recoveryPromise;
    }

    function sendBundleRequest(formData, retryIndex, attempt) {
      if (!attemptIsActive(attempt) || attempt.timedOut) return Promise.reject(new Error('Add attempt ended'));
      var request = {
        method: 'POST',
        headers: { Accept: 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      };
      if (attempt.controller) request.signal = attempt.controller.signal;
      attempt.sent = true;
      return global.fetch(root.getAttribute('data-cart-add-url'), request).then(function (response) {
        if (response.status === 429) {
          var delays = [700, 1600, 3500];
          if (retryIndex >= delays.length) {
            var limited = new Error(str('error_generic'));
            limited.gbldMessage = str('error_generic');
            limited.gbldNoMutation = true;
            throw limited;
          }
          return new Promise(function (resolve) {
            attempt.retryTimer = global.setTimeout(function () {
              attempt.retryTimer = null;
              resolve();
            }, delays[retryIndex]);
          }).then(function () { return sendBundleRequest(formData, retryIndex + 1, attempt); });
        }
        return response.json().then(function (data) {
          // Shopify may mutate before a 400/422 section/stock error. Status alone is not a no-op receipt.
          if (!data || data.status || !response.ok) {
            var message = (data && (data.description || data.message)) || str('error_generic');
            var rejected = new Error(message);
            rejected.gbldMessage = message;
            throw rejected;
          }
          return data;
        });
      });
    }

    function postBundle(formData, retryIndex, attempt) {
      return new Promise(function (resolve, reject) {
        var settled = false;
        try {
          if (typeof global.AbortController === 'function') attempt.controller = new global.AbortController();
        } catch (error) {}
        function settle(error, data) {
          if (settled) {
            if (!error && attemptIsActive(attempt)) finishAccepted(data, attempt, attempt.drawer);
            return;
          }
          settled = true;
          if (attempt.deadlineTimer != null) global.clearTimeout(attempt.deadlineTimer);
          attempt.deadlineTimer = null;
          attempt.cancelAdd = null;
          if (error) reject(error);
          else resolve(data);
        }
        attempt.cancelAdd = function () { settle(new Error('Add attempt cancelled')); };
        // One deadline covers fetch, JSON and every explicit-429 backoff.
        attempt.deadlineTimer = global.setTimeout(function () {
          attempt.timedOut = true;
          if (attempt.retryTimer != null) global.clearTimeout(attempt.retryTimer);
          attempt.retryTimer = null;
          settle(new Error('Add result unknown'));
          if (attempt.controller) {
            try { attempt.controller.abort(); } catch (error) {}
          }
        }, 20000);
        var sending;
        try { sending = sendBundleRequest(formData, retryIndex, attempt); }
        catch (error) { sending = Promise.reject(error); }
        Promise.resolve(sending).then(function (data) { settle(null, data); }, function (error) { settle(error); });
      });
    }

    function setError(message) {
      var errorNode = root.querySelector('[data-gbld-error]');
      if (!errorNode) return;
      errorNode.textContent = message || '';
      errorNode.hidden = !message;
    }

    function setBusy(value) {
      busy = value;
      if (submitButton) {
        submitButton.disabled = busy || (!pendingRecovery && (selections.size === 0 || (giftUnlocked && !giftId)));
        submitButton.classList.toggle('is-loading', busy);
      }
      if (submitText) submitText.textContent = busy ? (pendingRecovery ? 'Checking cart…' : str('submitting')) : (pendingRecovery ? 'View cart' : str('submit'));
    }

    // An accepted Shopify receipt is final even if a subscriber or drawer cannot paint it.
    function recoverAcceptedCart(data, attempt, drawer) {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) {
        try {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'product-form',
            productVariantId: Number(attempt.items[0].id),
            cartData: data
          });
        } catch (error) {}
      }
      var shown = false;
      if (drawer && typeof drawer.renderContents === 'function') {
        try {
          drawer.classList.remove('is-empty');
          if (typeof drawer.setActiveElement === 'function') drawer.setActiveElement(submitButton);
          drawer.renderContents(data);
          shown = true;
        } catch (error) {}
      }
      try { closeAllSheets(); }
      catch (error) { shown = false; }
      if (!shown) global.location.href = root.getAttribute('data-cart-url') || '/cart';
    }

    function finishAccepted(data, attempt, drawer) {
      if (!attemptIsActive(attempt)) return null;
      attempt.finalized = true;
      clearAttemptTimers(attempt);
      attempt.items.forEach(function (item) {
        if (item.gift) {
          if (String(giftId) === String(item.id)) giftId = null;
          return;
        }
        var key = String(item.id);
        var submitted = attempt.submitted.get(key);
        var lowest = attempt.lowest.get(key);
        var left = engine.leftAfterSubmit(selections.get(key) || 0, submitted, lowest);
        if (left > 0) selections.set(key, left);
        else selections.delete(key);
      });
      activeSubmit = null;
      // Keep the durable marker until consumed picks cannot restore after a reload.
      var protectedPicks = persist() || discardStaleStoredPicks();
      if (protectedPicks) {
        clearPendingMarker(attempt);
        if (pendingRecovery && pendingRecovery.token === attempt.token) pendingRecovery = null;
      } else pendingRecovery = { v: 1, token: attempt.token, accepted: true };
      cartFresh = false;
      setBusy(false);
      setError(pendingRecovery ? 'Your items were added. View your cart.' : '');
      var result = render(true);
      if (submitText && !pendingRecovery) submitText.textContent = str('submitted');
      if (feedbackTimer) global.clearTimeout(feedbackTimer);
      feedbackTimer = null;
      if (!pendingRecovery) feedbackTimer = global.setTimeout(function () {
        feedbackTimer = null;
        if (alive && !busy && !pendingRecovery && submitText) submitText.textContent = str('submit');
      }, 1600);
      recoverAcceptedCart(data, attempt, drawer);
      refreshCartAwareness(true).then(function (state) {
        if (!attempt.wasEmpty || !state || !Array.isArray(state.items)) return;
        var addedIds = {};
        attempt.items.forEach(function (item) { addedIds[String(item.id)] = true; });
        var actual = state.items.reduce(function (sum, line) {
          return addedIds[String(line.variant_id)] ? sum + Number(line.final_line_price || 0) : sum;
        }, 0);
        if (actual !== attempt.expected.total) {
          if (global.console && typeof global.console.warn === 'function') global.console.warn('[gbld] total mismatch', {
            expected: attempt.expected.total,
            actual: actual
          });
          emit('gbld:mismatch', { expected: attempt.expected.total, actual: actual });
        }
      });
      emit('gbld:added', { items: attempt.items, expectedTotal: attempt.expected.total });
      return result;
    }

    function submitBundle() {
      if (busy) return;
      if (pendingRecovery || getPendingMarker()) {
        if (!pendingRecovery) restorePending();
        global.location.href = root.getAttribute('data-cart-url') || '/cart';
        return;
      }
      if (selections.size === 0) return;
      setBusy(true);
      setError('');
      if (feedbackTimer) global.clearTimeout(feedbackTimer);
      feedbackTimer = null;
      var attempt = null;
      var idle = null;
      try { idle = global.GBCart && typeof global.GBCart.whenIdle === 'function' ? global.GBCart.whenIdle() : null; }
      catch (error) { idle = null; }
      withTimeout(idle, 8000).catch(function () {}).then(function () {
        if (!alive) return null;
        return ensureFreshCart();
      }).then(function () {
        if (!alive) return null;
        if (!selections.size) {
          setBusy(false);
          render(true);
          return null;
        }
        var expected = currentPrice();
        if (giftUnlocked && !giftId) {
          setBusy(false);
          render(true);
          if (giftBar && !giftBar.hidden && typeof giftBar.focus === 'function') giftBar.focus();
          return null;
        }
        var items = expected.lines.slice().sort(function (left, right) {
          var leftFact = factFor(left.id);
          var rightFact = factFor(right.id);
          return (leftFact && leftFact.eligible ? 0 : 1) - (rightFact && rightFact.eligible ? 0 : 1);
        }).map(function (line) {
          var lineFact = factFor(line.id);
          return {
            id: String(line.id), quantity: line.qty, eligible: !!(lineFact && lineFact.eligible),
            rewardEligible: engine.isGiftPaidLine({
              productId: lineFact && lineFact.productId, kind: lineFact && lineFact.kind, price: lineFact && lineFact.price,
              eligible: !!(lineFact && lineFact.eligible)
            }, giftPaidProductIds)
          };
        });
        var giftExp = root.getAttribute('data-gift-exp') || '';
        var giftMarker = root.getAttribute('data-gift-marker') || '';
        var sendGift = giftReady && giftUnlocked && !!giftId && !!giftExp && !!giftMarker;
        var mysteryQualifies = mysteryGiftReady && mysteryGiftUnlocked && !!giftExp &&
          mysteryGiftMarker === giftMarker + ':mystery';
        var rewardPlan = engine.planBundleRewards(items, {
          mysteryUnlocked: mysteryQualifies,
          mysteryAlreadyInCart: mysteryAlreadyInCart,
          mysteryId: mysteryGiftId,
          freeBlasterUnlocked: sendGift,
          freeBlasterId: giftId
        });
        items = rewardPlan.items;
        var before = lastCart;
        var wasEmpty = !!before && (Number(before.item_count) || 0) === 0;
        var submittedQuantities = new Map();
        var lowestQuantities = new Map();
        expected.lines.forEach(function (line) {
          var key = String(line.id);
          submittedQuantities.set(key, line.qty);
          lowestQuantities.set(key, line.qty);
        });
        activeSubmit = {
          token: String(Date.now()) + ':' + (++submitAttemptId),
          submitted: submittedQuantities, lowest: lowestQuantities,
          items: items, expected: expected, wasEmpty: wasEmpty,
          finalized: false, cancelled: false, sent: false
        };
        attempt = activeSubmit;
        var formData = new global.FormData();
        var sourceTag = root.getAttribute('data-gbld-src') || '';
        items.forEach(function (item, index) {
          formData.append('items[' + index + '][id]', item.id);
          formData.append('items[' + index + '][quantity]', String(item.quantity));
          // Paid bundle blasters and both reward lines share one cart/add request.
          if (rewardPlan.tagPaid && (item.rewardEligible || item.gift)) formData.append('items[' + index + '][properties][_bos_exp]', giftExp);
          if (item.mystery) formData.append('items[' + index + '][properties][_bos_gift]', mysteryGiftMarker);
          else if (item.gift) formData.append('items[' + index + '][properties][_bos_gift]', giftMarker);
          // GB-AUDIT-FIX-20261029: paid lines say they came from the builder page (orders can be counted).
          if (sourceTag && !item.gift && !item.mystery) formData.append('items[' + index + '][properties][_gb_src]', sourceTag);
        });
        var drawer = documentRef.querySelector('cart-drawer');
        var sections = drawer && typeof drawer.getSectionsToRender === 'function'
          ? drawer.getSectionsToRender().map(function (section) { return section.id; })
          : ['cart-drawer', 'cart-icon-bubble'];
        formData.append('sections', sections.join(','));
        formData.append('sections_url', global.location.pathname);
        attempt.drawer = drawer;
        // Guard readable saved picks before POST; fully unavailable storage cannot restore them.
        if (!recordPending(attempt)) {
          attempt.cancelled = true;
          activeSubmit = null;
          pendingRecovery = { v: 1, token: attempt.token, noPost: true };
          setBusy(false);
          render(true);
          var storageMessage = 'View your cart to continue.';
          setError(storageMessage);
          emit('gbld:error', { message: storageMessage });
          return null; // No POST was sent; expose usable cart access instead of a retry loop.
        }
        emit('gbld:submit', { items: items, expectedTotal: expected.total });
        return postBundle(formData, 0, attempt).then(function (data) {
          return finishAccepted(data, attempt, drawer);
        });
      }).catch(function (error) {
        if (!alive) return;
        if (attempt && attempt.finalized) {
          global.location.href = root.getAttribute('data-cart-url') || '/cart';
          return;
        }
        if (attempt && !attemptIsActive(attempt)) return;
        if (attempt && attempt.sent && !(error && error.gbldNoMutation)) return beginUnknownRecovery(attempt);
        if (attempt) {
          attempt.cancelled = true;
          clearAttemptTimers(attempt);
          clearPendingMarker(attempt);
        }
        activeSubmit = null;
        persist(); // An explicit no-mutation result makes all remaining choices safe to save again.
        setBusy(false);
        render(true);
        var message = error && Object.prototype.hasOwnProperty.call(error, 'gbldMessage')
          ? error.gbldMessage
          : str('error_generic');
        setError(message);
        emit('gbld:error', { message: message });
        refreshCartAwareness(true);
      });
    }

    function onClick(event) {
      var target = event.target && event.target.closest ? event.target.closest('[data-gbld-tab], [data-gbld-add], [data-gbld-inc], [data-gbld-dec], [data-gbld-variant], [data-gbld-open], [data-gbld-item-inc], [data-gbld-item-dec], [data-gbld-item], [data-gbld-gear-for], [data-gbld-summary-toggle], [data-gbld-summary-close], [data-gbld-backdrop], [data-gbld-submit], [data-gbld-qv], [data-gbld-qv-close], [data-gbld-qv-action], [data-gbld-qv-prev], [data-gbld-qv-next], [data-gbld-demo-jump], [data-gbld-demo-play], [data-gbld-meter], [data-gbld-giftbar], [data-gbld-gift], [data-gbld-gift-close], [data-gbld-gift-pick], [data-gbld-gift-swatch]') : null;
      if (!target || !root.contains(target)) return;
      if (target.matches('[data-gbld-tab]')) {
        updateTabs(target, true);
      } else if (target.matches('[data-gbld-variant]')) {
        handleVariant(target);
      } else if (target.matches('[data-gbld-add]')) {
        var addCard = target.closest('[data-gbld-card]');
        if (addCard) setQuantity(activeId(addCard), 1);
      } else if (target.matches('[data-gbld-inc]') || target.matches('[data-gbld-dec]')) {
        var card = target.closest('[data-gbld-card]');
        if (card) changeQuantity(activeId(card), target.matches('[data-gbld-inc]') ? 1 : -1);
      } else if (target.matches('[data-gbld-item-inc]') || target.matches('[data-gbld-item-dec]')) {
        var row = target.closest('[data-gbld-item]');
        if (row) changeQuantity(row.getAttribute('data-id'), target.matches('[data-gbld-item-inc]') ? 1 : -1);
      } else if (target.matches('[data-gbld-item]') && target.getAttribute('data-gift') === 'true') {
        openGiftDialog(target);
      } else if (target.matches('[data-gbld-gear-for]')) {
        showGearFor(target);
      } else if (target.matches('[data-gbld-open]')) {
        var openCard = target.closest('[data-gbld-card]');
        if (openCard) openQuickView(openCard, target);
      } else if (target.matches('[data-gbld-summary-toggle]')) {
        setSummaryOpen(!summaryOpen, false);
      } else if (target.matches('[data-gbld-meter]')) {
        if (global.innerWidth < 1000 && !summaryOpen) setSummaryOpen(true, false);
      } else if (target.matches('[data-gbld-summary-close]') || target.matches('[data-gbld-backdrop]')) {
        setSummaryOpen(false, true);
      } else if (target.matches('[data-gbld-submit]')) {
        submitBundle();
      } else if (target.matches('[data-gbld-demo-jump]')) {
        var demoIndex = readInteger(target.getAttribute('data-gbld-demo-index'), -1);
        if (demoIndex >= 0) setQuickViewGalleryIndex(demoIndex, true);
      } else if (target.matches('[data-gbld-demo-play]')) {
        playQuickViewDemo(target);
      } else if (target.matches('[data-gbld-qv-prev]')) {
        setQuickViewGalleryIndex(activeGalleryIndex - 1, true);
      } else if (target.matches('[data-gbld-qv-next]')) {
        setQuickViewGalleryIndex(activeGalleryIndex + 1, true);
      } else if (target.matches('[data-gbld-qv-close]')) {
        closeQuickView(true);
      } else if (target.matches('[data-gbld-qv]') && event.target === target) {
        closeQuickView(true);
      } else if (target.matches('[data-gbld-qv-action]')) {
        if (!quickViewCard) return;
        var qvId = activeId(quickViewCard);
        if (selections.has(qvId)) {
          setQuantity(qvId, 0);
        } else {
          setQuantity(qvId, 1);
          if (qvCloseTimer) global.clearTimeout(qvCloseTimer);
          qvCloseTimer = global.setTimeout(function () { closeQuickView(true); }, 600);
        }
      } else if (target.matches('[data-gbld-giftbar]')) {
        openGiftDialog(target);
      } else if (target.matches('[data-gbld-gift-close]')) {
        closeGiftDialog(true);
      } else if (target.matches('[data-gbld-gift]') && event.target === target) {
        closeGiftDialog(true);
      } else if (target.matches('[data-gbld-gift-swatch]')) {
        var giftOption = target.closest('[data-gbld-gift-option]');
        var giftCandidate = giftOption && giftCandidateByProduct.get(giftOption.getAttribute('data-product-id') || '');
        if (!giftCandidate || !giftCandidateByVariant.has(String(target.getAttribute('data-id')))) return;
        Array.prototype.forEach.call(giftOption.querySelectorAll('[data-gbld-gift-swatch]'), function (swatch) {
          swatch.classList.toggle('is-active', swatch === target);
        });
        giftOptionImage(giftOption, giftFactFor(target.getAttribute('data-id')));
        if (setGift(target.getAttribute('data-id'))) closeGiftAfterPick();
      } else if (target.matches('[data-gbld-gift-pick]')) {
        var option = target.closest('[data-gbld-gift-option]');
        var candidate = option && giftCandidateByProduct.get(option.getAttribute('data-product-id') || '');
        if (!candidate || !candidate.variants.length) return;
        var selectedSwatch = option.querySelector('[data-gbld-gift-swatch].is-active');
        var selectedGiftId = selectedSwatch ? selectedSwatch.getAttribute('data-id') : candidate.variants[0].id;
        if (setGift(selectedGiftId)) closeGiftAfterPick();
      }
    }

    function onKeydown(event) {
      if (event.key === 'Escape') {
        if (giftDialogOpen) closeGiftDialog(true);
        else if (quickViewOpen) closeQuickView(true);
        else if (summaryOpen) setSummaryOpen(false, true);
        return;
      }
      var tab = event.target && event.target.closest ? event.target.closest('[data-gbld-tab]') : null;
      if (tab && root.contains(tab) && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].indexOf(event.key) !== -1) {
        var tabList = Array.prototype.slice.call(root.querySelectorAll('[data-gbld-tab]'));
        var index = tabList.indexOf(tab);
        if (event.key === 'ArrowLeft') index = (index - 1 + tabList.length) % tabList.length;
        else if (event.key === 'ArrowRight') index = (index + 1) % tabList.length;
        else if (event.key === 'Home') index = 0;
        else index = tabList.length - 1;
        if (tabList[index]) {
          event.preventDefault();
          updateTabs(tabList[index], true);
          tabList[index].focus();
        }
        return;
      }
      var radio = event.target && event.target.closest
        ? event.target.closest('[data-gbld-variant][role="radio"]')
        : null;
      var radioGroup = radio && radio.closest ? radio.closest('[data-gbld-variants], [data-gbld-qv-variants]') : null;
      if (radio && radioGroup && root.contains(radioGroup) &&
          ['ArrowRight', 'ArrowDown', 'ArrowLeft', 'ArrowUp'].indexOf(event.key) !== -1) {
        var radios = Array.prototype.slice.call(radioGroup.querySelectorAll('[data-gbld-variant][role="radio"]'))
          .filter(function (item) { return !item.hidden; });
        var radioIndex = radios.indexOf(radio);
        if (radioIndex !== -1 && radios.length) {
          var nextRadio = event.key === 'ArrowRight' || event.key === 'ArrowDown'
            ? (radioIndex + 1) % radios.length
            : (radioIndex - 1 + radios.length) % radios.length;
          var chosenRadio = radios[nextRadio];
          var chosenId = chosenRadio.getAttribute('data-id') || '';
          event.preventDefault();
          chosenRadio.focus();
          chosenRadio.click();
          // The quick view redraws its colour buttons after every change; keep the keyboard focus on the chosen colour.
          if (chosenId && !radioGroup.contains(chosenRadio)) {
            var redrawn = Array.prototype.slice.call(radioGroup.querySelectorAll('[data-gbld-variant][role="radio"]'))
              .find(function (item) { return item.getAttribute('data-id') === chosenId; });
            if (redrawn) redrawn.focus();
          }
        }
        return;
      }
      if (event.key !== 'Tab') return;
      var container = giftDialogOpen ? giftDialog : quickViewOpen ? quickView : summaryOpen ? summary : null;
      var nodes = focusables(container);
      if (!nodes.length) return;
      var first = nodes[0];
      var last = nodes[nodes.length - 1];
      if (event.shiftKey && (event.target === first || !container.contains(event.target))) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && (event.target === last || !container.contains(event.target))) {
        event.preventDefault();
        first.focus();
      }
    }

    function onQuickViewGalleryScroll() {
      if (qvGalleryTimer) global.clearTimeout(qvGalleryTimer);
      qvGalleryTimer = global.setTimeout(syncQuickViewGalleryIndex, 90);
    }

    function onQuickViewScroll() {
      if (!activeDemoSlide || !quickViewScroll) return;
      var slideRect = activeDemoSlide.getBoundingClientRect();
      var viewportRect = quickViewScroll.getBoundingClientRect();
      if (slideRect.bottom <= viewportRect.top || slideRect.top >= viewportRect.bottom) stopQuickViewDemo();
    }

    function onVisibilityChange() {
      if (documentRef.hidden || documentRef.visibilityState === 'hidden') stopQuickViewDemo();
    }

    function onUnload(event) {
      var target = event.target;
      if (!target) return;
      var match = target === root || (target.contains && target.contains(root)) || (root.contains && root.contains(target));
      if (!match && event.detail && event.detail.sectionId) {
        match = root.id === 'gbld-' + event.detail.sectionId;
      }
      if (match) cleanup();
    }

    function onResize() {
      if (global.innerWidth >= 1000 && summaryOpen) setSummaryOpen(false, false);
      var active = root.querySelector('[data-gbld-tab].is-active') || root.querySelector('[data-gbld-tab]');
      if (active) {
        tabPill.style.transform = 'translateX(' + active.offsetLeft + 'px)';
        tabPill.style.width = String(active.offsetWidth) + 'px';
      }
      addonPanelStates.forEach(scheduleGroupTitleFit);
    }

    function onPageShow(event) {
      if (!event || event.persisted !== true) return;
      cartFresh = false;
      ensureFreshCart(true).then(function () {
        if (alive) render(true);
      });
    }

    function removeCartBindRetryListeners() {
      if (cartDomContentHandler) documentRef.removeEventListener('DOMContentLoaded', cartDomContentHandler);
      if (cartWindowLoadHandler) global.removeEventListener('load', cartWindowLoadHandler);
      if (cartReadyHandler) documentRef.removeEventListener('gb:cart-ready', cartReadyHandler);
      cartDomContentHandler = null;
      cartWindowLoadHandler = null;
      cartReadyHandler = null;
    }

    function cartSignature(snapshot) {
      if (!snapshot) return '0';
      var parts = [Number(snapshot.item_count) || 0, Number(snapshot.total_price) || 0];
      if (Array.isArray(snapshot.items)) {
        snapshot.items.forEach(function (item) {
          if (item) parts.push(String(item.key || item.variant_id || '') + 'x' + (Number(item.quantity) || 0));
        });
      }
      return parts.join('|');
    }

    function bindCart() {
      if (!alive || cartBound) return cartBound;
      var api = global.GBCart;
      if (!api || typeof api.subscribe !== 'function') return false;
      try {
        var stop = api.subscribe(function (snapshot) {
          // Count alone misses a swap inside the cart (one line out, another in), so compare lines and total too.
          var signature = cartSignature(snapshot);
          if (lastCartSignature === null || signature !== lastCartSignature) {
            lastCartSignature = signature;
            cartFresh = false;
            ensureFreshCart(false, snapshot, true);
          }
        });
        unsubscribe = typeof stop === 'function' ? stop : null;
        cartBound = true;
        removeCartBindRetryListeners();
        refreshCartAwareness(false);
        return true;
      } catch (error) { return false; }
    }

    function retryCartBinding() {
      if (bindCart() || !alive) return;
      cartDomContentHandler = function () { bindCart(); };
      cartWindowLoadHandler = function () { bindCart(); };
      // The store's cart helper fires this once its methods exist; it also covers a section that starts after page load.
      cartReadyHandler = function () { bindCart(); };
      documentRef.addEventListener('DOMContentLoaded', cartDomContentHandler);
      global.addEventListener('load', cartWindowLoadHandler);
      documentRef.addEventListener('gb:cart-ready', cartReadyHandler);
    }

    function replayEarlyClicks() {
      var early = global.__gbldEarly;
      if (!Array.isArray(early)) return;
      var index = 0;
      while (index < early.length) {
        var element = early[index];
        if (!element || !root.contains(element)) {
          index += 1;
          continue;
        }
        early.splice(index, 1);
        var connected = typeof element.isConnected === 'boolean'
          ? element.isConnected
          : !!(documentRef.documentElement && documentRef.documentElement.contains(element));
        if (connected && !element.disabled && typeof element.click === 'function') element.click();
      }
    }

    function cleanup() {
      if (!alive) return;
      alive = false;
      if (activeSubmit) {
        activeSubmit.cancelled = true;
        clearAttemptTimers(activeSubmit);
        activeSubmit = null;
      }
      if (rootClickHandler) root.removeEventListener('click', rootClickHandler);
      if (rootKeyHandler) root.removeEventListener('keydown', rootKeyHandler);
      if (documentUnloadHandler) documentRef.removeEventListener('shopify:section:unload', documentUnloadHandler);
      if (windowResizeHandler) global.removeEventListener('resize', windowResizeHandler);
      if (pageshowHandler) global.removeEventListener('pageshow', pageshowHandler);
      if (quickViewGalleryScrollHandler && quickViewGallery) quickViewGallery.removeEventListener('scroll', quickViewGalleryScrollHandler);
      if (quickViewScrollHandler && quickViewScroll) quickViewScroll.removeEventListener('scroll', quickViewScrollHandler);
      if (visibilityHandler) documentRef.removeEventListener('visibilitychange', visibilityHandler);
      removeCartBindRetryListeners();
      if (typeof unsubscribe === 'function') unsubscribe();
      if (feedbackTimer) global.clearTimeout(feedbackTimer);
      if (qvCloseTimer) global.clearTimeout(qvCloseTimer);
      if (qvGalleryTimer) global.clearTimeout(qvGalleryTimer);
      if (giftCloseTimer) global.clearTimeout(giftCloseTimer);
      addonPanelStates.forEach(function (state) {
        if (state.fitFrame != null && typeof global.cancelAnimationFrame === 'function') global.cancelAnimationFrame(state.fitFrame);
        state.fitFrame = null;
        state.fitQueued = false;
      });
      groupFlashTimers.forEach(function (timer) { global.clearTimeout(timer); });
      groupFlashTimers = [];
      stopQuickViewDemo();
      closeAllSheets();
      setLock(false);
      root.removeAttribute('data-gbld-ready');
    }

    rootClickHandler = onClick;
    rootKeyHandler = onKeydown;
    documentUnloadHandler = onUnload;
    windowResizeHandler = onResize;
    pageshowHandler = onPageShow;
    quickViewGalleryScrollHandler = onQuickViewGalleryScroll;
    quickViewScrollHandler = onQuickViewScroll;
    visibilityHandler = onVisibilityChange;

    root.addEventListener('click', rootClickHandler);
    root.addEventListener('keydown', rootKeyHandler);
    documentRef.addEventListener('shopify:section:unload', documentUnloadHandler);
    global.addEventListener('resize', windowResizeHandler);
    global.addEventListener('pageshow', pageshowHandler);
    if (quickViewGallery) quickViewGallery.addEventListener('scroll', quickViewGalleryScrollHandler, { passive: true });
    if (quickViewScroll) quickViewScroll.addEventListener('scroll', quickViewScrollHandler, { passive: true });
    documentRef.addEventListener('visibilitychange', visibilityHandler);

    cards.forEach(function (card) {
      var id = activeId(card);
      var productId = card.getAttribute('data-product-id') || '';
      if (id && !activeByProduct.has(productId)) activeByProduct.set(productId, id);
    });
    var normalizedProducts = new Set();
    cards.forEach(function (card) {
      var productId = card.getAttribute('data-product-id') || '';
      if (normalizedProducts.has(productId)) return;
      normalizedProducts.add(productId);
      var id = activeByProduct.get(productId);
      if (id) activateVariant(card, id);
    });
    restore();
    restorePending();
    showRestoredPicks();
    root.setAttribute('data-gbld-ready', '1');
    var firstTab = root.querySelector('[data-gbld-tab]');
    if (firstTab) updateTabs(firstTab, false);
    render(false);
    if (documentRef.fonts && documentRef.fonts.ready && typeof documentRef.fonts.ready.then === 'function') {
      documentRef.fonts.ready.then(function () { addonPanelStates.forEach(scheduleGroupTitleFit); }, function () {});
    }
    retryCartBinding();
    replayEarlyClicks();
    applyLinkedPick();
    return true;

    // GB-AUDIT-FIX-20261029: a product-page link opens the builder with that blaster already picked
    // (/pages/build-your-bundle?add=<variant id>). Builder page only; the parameter is dropped from the
    // address at once, so a reload or Back never picks it twice; a blaster that is already picked stays as it is.
    function applyLinkedPick() {
      if (!root.getAttribute('data-gbld-src')) return;
      var match = /[?&]add=(\d{6,20})(?:&|#|$)/.exec(String((global.location && global.location.search) || ''));
      if (!match) return;
      var id = match[1];
      try {
        var rest = String(global.location.search || '').replace(/^\?/, '').split('&').filter(function (pair) {
          return pair && !/^add=/.test(pair);
        }).join('&');
        global.history.replaceState(global.history.state, '', global.location.pathname + (rest ? '?' + rest : '') + global.location.hash);
      } catch (error) {}
      var swatch = root.querySelector('[data-gbld-card][data-kind="blaster"] [data-gbld-variant][data-id="' + id + '"]');
      // A colour the builder hides (the old "Classic" Raven colours on the Brick listing) picks the same colour on
      // the card that sells it now (same family, same colour name without "Classic").
      if (swatch && swatch.tagName === 'BUTTON' && swatch.hidden) {
        var family = swatch.getAttribute('data-family') || '';
        var colour = String(swatch.getAttribute('data-title') || '').replace(/^classic\s+/i, '');
        swatch = Array.prototype.find.call(root.querySelectorAll('[data-gbld-card][data-kind="blaster"] [data-gbld-variant]'), function (node) {
          return !node.hidden && node.getAttribute('data-family') === family &&
            String(node.getAttribute('data-title') || '').replace(/^classic\s+/i, '') === colour;
        }) || null;
        id = swatch ? String(swatch.getAttribute('data-id') || '') : '';
      }
      var card = swatch && swatch.closest('[data-gbld-card]');
      if (!card || !id) return;
      activateVariant(card, id);
      // Already picked (this colour or another one of the same blaster): show the linked colour, never add a second.
      if (card.classList.contains('is-selected')) {
        render(true);
        return;
      }
      setQuantity(id, 1);
    }

    // GB-AUDIT-FIX-20261029: after a reload each card opens on its picked colour, not on its default one
    // (on the builder page the default is the lowest price, which can differ from the pick).
    function showRestoredPicks() {
      selections.forEach(function (qty, id) {
        if (!(qty > 0)) return;
        var node = root.querySelector('[data-gbld-card] [data-gbld-variant][data-id="' + id + '"]');
        var card = node && node.closest('[data-gbld-card]');
        if (!card || (node.tagName === 'BUTTON' && node.hidden)) return;
        if ((selections.get(activeId(card)) || 0) > 0) return;
        activateVariant(card, id);
      });
    }
  }

  global.GBLD = { version: '1.4.3', engine: engine, init: init };

  function boot() {
    if (!documentRef || !documentRef.querySelectorAll) return;
    Array.prototype.forEach.call(documentRef.querySelectorAll('[data-gbld-root]'), init);
  }

  // Theme editor: the replacement section arrives after the old root cleaned up, so this listener lives outside init.
  documentRef.addEventListener('shopify:section:load', function (event) {
    var target = event && event.target;
    if (!target) return;
    if (target.matches && target.matches('[data-gbld-root]')) init(target);
    if (target.querySelectorAll) Array.prototype.forEach.call(target.querySelectorAll('[data-gbld-root]'), init);
  });

  var documentWasLoading = documentRef.readyState === 'loading';
  boot();
  if (documentWasLoading) documentRef.addEventListener('DOMContentLoaded', boot, { once: true });
})(typeof window !== 'undefined' ? window : null);
